<template>
  <div class="container">
    <h3 class="subtitle green has-text-weight-bold">
      {{ $translate('attach') }}
    </h3>
    <div class="columns">
      <div class="column is-6">
        <div class="card">
          <div class="columns">
            <div class="column is-3 has-text-centered">
              <b-button
                size="is-medium"
                :disabled="
                  order.pair === 'right' ||
                    order.orderTypeVariant == 'card' ||
                    order.orderTypeVariant == 'card2' ||
                    (order.orderTypeVariant == 'formplusplant' && order.orderTypeSubVariant != 'file3D') ||
                    (order.orderTypeVariant == 'form' && order.orderTypeSubVariant != 'file3D')
                "
                icon-left="scanner"
                :class="[
                  missingattachment &&
                  order.orderTypeMain == 'digitalMeasurements' &&
                  order.orderTypeVariant != 'formproj'
                    ? 'is-danger'
                    : order.attachment.scan_fms_sx != null &&
                      order.attachment.scan_pln_sx != null &&
                      order.attachment.scan_stl_sx != null
                    ? 'is-uploaded'
                    : order.attachment.scan_fms_sx != null ||
                      order.attachment.scan_pln_sx != null ||
                      order.attachment.scan_stl_sx != null
                    ? 'is-semiuploaded'
                    : 'is-primary',
                ]"
                inverted
                @click="isComponentModalScanSx = true"
              >
                <span>{{ $translate('duna') }}</span>
              </b-button>
            </div>
            <div class="column is-3 has-text-centered">
              <b-button
                :disabled="
                  order.pair === 'right' ||
                    order.orderTypeVariant == 'card' ||
                    order.orderTypeVariant == 'card2' ||
                    (order.orderTypeVariant == 'formplusplant' && order.orderTypeSubVariant != 'file3D') ||
                    (order.orderTypeVariant == 'form' && order.orderTypeSubVariant != 'file3D')
                "
                size="is-medium"
                icon-left="scanner"
                :class="[
                  order.attachment.scan_no_duna_sx != null
                    ? 'is-uploaded'
                    : missingattachment && order.orderTypeMain != 'measurements'
                    ? 'is-danger'
                    : 'is-primary',
                ]"
                inverted
                @click="isComponentModalScanNoDUSx = true"
              >
                <span>{{ $translate('scan') }}</span>
              </b-button>
            </div>
            <div class="column is-3 has-text-centered">
              <b-button
                size="is-medium"
                :disabled="
                  order.pair === 'right' ||
                    ((order.orderTypeVariant == 'formplusplant' || order.orderTypeVariant == 'form') &&
                      order.orderTypeSubVariant != 'file3D')
                "
                icon-left="fingerprint"
                :class="[
                  order.attachment.grap_sx != null
                    ? 'is-uploaded'
                    : missingattachment && order.orderTypeMain == 'measurements'
                    ? 'is-danger'
                    : 'is-primary',
                ]"
                inverted
                @click="isComponentModalGrapSx = true"
              >
                <span>{{ $translate('grap') }}</span>
              </b-button>
            </div>
            <div class="column is-3 has-text-centered">
              <b-button
                :disabled="order.pair === 'right'"
                size="is-medium"
                icon-left="paperclip"
                :class="[order.attachment.attach_sx != null ? 'is-uploaded' : 'is-primary']"
                inverted
                @click="isComponentModalAttachSx = true"
              >
                <span>{{ $translate('attach') }}</span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="card">
          <div class="columns">
            <div class="column is-3 has-text-centered">
              <!-- porco -->
              <b-button
                size="is-medium"
                :disabled="
                  order.pair === 'left' ||
                    order.orderTypeVariant == 'card' ||
                    order.orderTypeVariant == 'card2' ||
                    (order.orderTypeVariant == 'formplusplant' && order.orderTypeSubVariant != 'file3D') ||
                    (order.orderTypeVariant == 'form' && order.orderTypeSubVariant != 'file3D')
                "
                icon-left="scanner"
                :class="[
                  missingattachment &&
                  order.orderTypeMain == 'digitalMeasurements' &&
                  order.orderTypeVariant != 'formproj'
                    ? 'is-danger'
                    : order.attachment.scan_fms_dx != null &&
                      order.attachment.scan_pln_dx != null &&
                      order.attachment.scan_stl_dx != null
                    ? 'is-uploaded'
                    : order.attachment.scan_fms_dx != null ||
                      order.attachment.scan_pln_dx != null ||
                      order.attachment.scan_stl_dx != null
                    ? 'is-semiuploaded'
                    : 'is-primary',
                ]"
                inverted
                @click="isComponentModalScanDx = true"
              >
                <span>{{ $translate('duna') }}</span>
              </b-button>
            </div>
            <div class="column is-3 has-text-centered">
              <b-button
                size="is-medium"
                :disabled="
                  order.pair === 'left' ||
                    order.orderTypeVariant == 'card' ||
                    order.orderTypeVariant == 'card2' ||
                    (order.orderTypeVariant == 'formplusplant' && order.orderTypeSubVariant != 'file3D') ||
                    (order.orderTypeVariant == 'form' && order.orderTypeSubVariant != 'file3D')
                "
                icon-left="scanner"
                :class="[
                  order.attachment.scan_no_duna_dx != null
                    ? 'is-uploaded'
                    : missingattachment && order.orderTypeMain != 'measurements'
                    ? 'is-danger'
                    : 'is-primary',
                ]"
                inverted
                @click="isComponentModalScanNoDUDx = true"
              >
                <span>{{ $translate('scan') }}</span>
              </b-button>
            </div>

            <div class="column is-3 has-text-centered">
              <b-button
                size="is-medium"
                :disabled="
                  order.pair === 'left' ||
                    ((order.orderTypeVariant == 'formplusplant' || order.orderTypeVariant == 'form') &&
                      order.orderTypeSubVariant != 'file3D')
                "
                icon-left="fingerprint"
                :class="[
                  order.attachment.grap_dx != null
                    ? 'is-uploaded'
                    : missingattachment && order.orderTypeMain == 'measurements'
                    ? 'is-danger'
                    : 'is-primary',
                ]"
                inverted
                @click="isComponentModalGrapDx = true"
              >
                <span>{{ $translate('grap') }}</span>
              </b-button>
            </div>
            <div class="column is-3 has-text-centered">
              <b-button
                :disabled="order.pair === 'left'"
                size="is-medium"
                icon-left="paperclip"
                :class="[order.attachment.attach_dx != null ? 'is-uploaded' : 'is-primary']"
                inverted
                @click="isComponentModalAttachDx = true"
              >
                <span>{{ $translate('attach') }}</span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal :active.sync="isComponentModalScanSx" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('scan') }}
          </p>
        </header>
        <section class="modal-card-body">
          <div
            v-if="
              order.attachment.scan_stl_sx != null &&
                order.attachment.scan_fms_sx != null &&
                order.attachment.scan_pln_sx != null
            "
          >
            <b-button class="is-danger" :disabled="disabledbool" @click="removedScanSX()">
              {{ $translate('remove_scan') }}
            </b-button>
            <template v-if="order.attachmentflag['scan_stl_sx'] == 1">
              <a target="_blank" :href="order.attachment['scan_stl_sx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file_stl') }}
                </b-button>
              </a>
              <a target="_blank" :href="order.attachment['scan_fms_sx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file_fms') }}
                </b-button>
              </a>
              <a target="_blank" :href="order.attachment['scan_pln_sx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file_pln') }}
                </b-button>
              </a>
            </template>
          </div>

          <b-field
            v-else
            class="file"
            :type="{ 'is-danger': errors.has('scan_sx') }"
            :message="errors.first('scan_sx')"
          >
            <b-upload
              v-model="order.scans_sx"
              v-validate="'threeneeding'"
              name="scan_sx"
              accept=".stl,.fms,.pln"
              multiple
              drag-drop
              :disabled="disabledbool"
              @input="orderScansSX()"
            >
              <section class="section">
                <div class="content has-text-centered">
                  <p>
                    <b-icon icon="upload" size="is-large" />
                  </p>
                  <p>{{ $translate('dummy_text_drop_scan') }}</p>
                </div>
              </section>
            </b-upload>
          </b-field>
          <div class="tags">
            <span v-for="(file, index) in order.scans_sx" :key="index" class="tag is-primary">
              {{ file.name }}
              <button class="delete is-small" type="button" @click="deleteScanSx(index)" />
            </span>
          </div>
          <tr v-for="variant in $highlowmeasu" :key="variant.key">
            <template v-for="x in ['center', '_sx']">
              <td :key="x" style="text-align: center; vertical-align: middle; width: 33%">
                <strong v-if="x == 'center'">{{ $translate(variant.key) }}</strong>
                <b-field v-else :key="x">
                  <b-input
                    v-model="tempfootmeasurementssx[variant.key + x]"
                    type="number"
                    :disabled="true"
                    :placeholder="$translate('placeholder_numeric_mm')"
                    step="1"
                    @input="checkValue()"
                  />
                </b-field>
              </td>
            </template>
          </tr>
        </section>

        <footer class="modal-card-foot">
          <button
            class="button"
            type="button"
            :disabled="order.attachment['scan_fms_sx'] == null"
            @click="isComponentModalScanSxComparison = true"
          >
            {{ $translate('comparison') | capitalize }}
          </button>
          <button class="button" type="button" @click="isComponentModalScanSx = false">
            {{ $translate('exit_without_saving') }}
          </button>
          <button
            class="button"
            type="button"
            :disabled="disabledbool"
            @click="
              importScanSxFromTemp()
              isComponentModalScanSx = false
            "
          >
            {{ $translate('exit_and_saving') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalScanSxComparison" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('comparison') | capitalize }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field class="file">
            <b-upload v-model="scan_fms_scan_sx" accept=".fms" @input="orderScansSXComparison()">
              <a class="button is-primary" :disabled="disabledbool">
                <b-icon icon="upload" />
                <span>{{ $translate('upload_button') }}</span>
              </a>
            </b-upload>
          </b-field>

          <tr v-for="variant in $highlowmeasu" :key="variant.key">
            <template v-for="x in ['_sx', 'center', 'scan_sx']">
              <td :key="x" style="text-align: center; vertical-align: middle; width: 33%">
                <strong v-if="x == 'center'">{{ $translate(variant.key) }}</strong>
                <b-field v-else :key="x">
                  <b-input
                    v-model="tempfootmeasurementssx[variant.key + x]"
                    type="number"
                    :disabled="true"
                    :placeholder="$translate('placeholder_numeric_mm')"
                    step="1"
                    @input="checkValue()"
                  />
                </b-field>
              </td>
            </template>
          </tr>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalScanSxComparison = false">
            {{ $translate('close') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalScanDx" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('scan') }}
          </p>
        </header>
        <section class="modal-card-body">
          <div
            v-if="
              order.attachment.scan_stl_dx != null &&
                order.attachment.scan_fms_dx != null &&
                order.attachment.scan_pln_dx != null
            "
          >
            <b-button class="is-danger" :disabled="disabledbool" @click="removedScanDX()">
              {{ $translate('remove_scan') }}
            </b-button>
            <template v-if="order.attachmentflag['scan_stl_dx'] == 1">
              <a target="_blank" :href="order.attachment['scan_stl_dx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file_stl') }}
                </b-button>
              </a>
              <a target="_blank" :href="order.attachment['scan_fms_dx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file_fms') }}
                </b-button>
              </a>
              <a target="_blank" :href="order.attachment['scan_pln_dx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file_pln') }}
                </b-button>
              </a>
            </template>
          </div>

          <b-field
            v-else
            class="file"
            :type="{ 'is-danger': errors.has('scan_dx') }"
            :message="errors.first('scan_dx')"
          >
            <b-upload
              v-model="order.scans_dx"
              v-validate="'threeneeding'"
              name="scan_dx"
              accept=".stl,.fms,.pln"
              multiple
              drag-drop
              :disabled="disabledbool"
              @input="orderScansDX()"
            >
              <section class="section">
                <div class="content has-text-centered">
                  <p>
                    <b-icon icon="upload" size="is-large" />
                  </p>
                  <p>{{ $translate('dummy_text_drop_scan') }}</p>
                </div>
              </section>
            </b-upload>
          </b-field>
          <div class="tags">
            <span v-for="(file, index) in order.scans_dx" :key="index" class="tag is-primary">
              {{ file.name }}
              <button class="delete is-small" type="button" @click="deleteScanDx(index)" />
            </span>
          </div>
          <tr v-for="variant in $highlowmeasu" :key="variant.key">
            <template v-for="x in ['center', '_dx']">
              <td :key="x" style="text-align: center; vertical-align: middle; width: 33%">
                <strong v-if="x == 'center'">{{ $translate(variant.key) }}</strong>
                <b-field v-else :key="x">
                  <b-input
                    v-model="tempfootmeasurementsdx[variant.key + x]"
                    type="number"
                    :disabled="true"
                    :placeholder="$translate('placeholder_numeric_mm')"
                    step="1"
                    @input="checkValue()"
                  />
                </b-field>
              </td>
            </template>
          </tr>
        </section>

        <footer class="modal-card-foot">
          <button
            class="button"
            type="button"
            :disabled="order.attachment['scan_fms_dx'] == null"
            @click="isComponentModalScanDxComparison = true"
          >
            {{ $translate('comparison') | capitalize }}
          </button>
          <button class="button" type="button" @click="isComponentModalScanDx = false">
            {{ $translate('exit_without_saving') }}
          </button>
          <button
            class="button"
            type="button"
            :disabled="disabledbool"
            @click="
              importScanDxFromTemp()
              isComponentModalScanDx = false
            "
          >
            {{ $translate('exit_and_saving') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalScanDxComparison" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('comparison') | capitalize }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field class="file">
            <b-upload v-model="scan_fms_scan_dx" accept=".fms" @input="orderScansDXComparison()">
              <a class="button is-primary" :disabled="disabledbool">
                <b-icon icon="upload" />
                <span>{{ $translate('upload_button') }}</span>
              </a>
            </b-upload>
          </b-field>

          <tr v-for="variant in $highlowmeasu" :key="variant.key">
            <template v-for="x in ['_dx', 'center', 'scan_dx']">
              <td :key="x" style="text-align: center; vertical-align: middle; width: 33%">
                <strong v-if="x == 'center'">{{ $translate(variant.key) }}</strong>
                <b-field v-else :key="x">
                  <b-input
                    v-model="tempfootmeasurementssx[variant.key + x]"
                    type="number"
                    :disabled="true"
                    :placeholder="$translate('placeholder_numeric_mm')"
                    step="1"
                    @input="checkValue()"
                  />
                </b-field>
              </td>
            </template>
          </tr>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalScanDxComparison = false">
            {{ $translate('close') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalScanNoDUSx" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('scan') }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field :label="$translate('scan')">
            <b-field
              v-if="order.attachmentflag['scan_no_duna_sx'] == null || order.attachmentflag['scan_no_duna_sx'] == 0"
              class="file"
              :type="{ 'is-danger': errors.has('scan_sx') }"
              :message="errors.first('scan_sx')"
            >
              <b-upload
                v-model="order.attachment['scan_no_duna_sx']"
                :disabled="disabledbool"
                :name="'scan_no_duna_sx'"
                accept=".stl"
              >
                <a class="button is-primary" :disabled="disabledbool">
                  <b-icon icon="upload" />
                  <span>{{ $translate('upload_button') }}</span>
                </a>
              </b-upload>
              <span v-if="order.attachment['scan_no_duna_sx']" class="file-name">
                {{ order.attachment['scan_no_duna_sx'].name }}
              </span>
              <b-button
                :disabled="!order.attachment['scan_no_duna_sx']"
                icon-left="minus"
                class="is-danger"
                @click="removedFile('scan_no_duna_sx')"
              >
                {{ $translate('remove_file') }}
              </b-button>
            </b-field>
            <div v-else>
              <a target="_blank" :href="order.attachment['scan_no_duna_sx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file') }}
                </b-button>
              </a>
              <br />
              <b-button :disabled="disabledbool" icon-left="minus" @click="removedFile('scan_no_duna_sx')">
                {{ $translate('remove_file') }}
              </b-button>
            </div>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalScanNoDUSx = false">
            {{ $translate('close') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalScanNoDUDx" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('scan') }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field :label="$translate('scan')">
            <b-field
              v-if="order.attachmentflag['scan_no_duna_dx'] == null || order.attachmentflag['scan_no_duna_dx'] == 0"
              class="file"
              :type="{ 'is-danger': errors.has('scan_dx') }"
              :message="errors.first('scan_dx')"
            >
              <b-upload
                v-model="order.attachment['scan_no_duna_dx']"
                :disabled="disabledbool"
                :name="'scan_no_duna_dx'"
                accept=".stl"
              >
                <a class="button is-primary" :disabled="disabledbool">
                  <b-icon icon="upload" />
                  <span>{{ $translate('upload_button') }}</span>
                </a>
              </b-upload>
              <span v-if="order.attachment['scan_no_duna_dx']" class="file-name">
                {{ order.attachment['scan_no_duna_dx'].name }}
              </span>
              <b-button
                :disabled="!order.attachment['scan_no_duna_dx']"
                icon-left="minus"
                class="is-danger"
                @click="removedFile('scan_no_duna_dx')"
              >
                {{ $translate('remove_file') }}
              </b-button>
            </b-field>
            <div v-else>
              <a target="_blank" :href="order.attachment['scan_no_duna_dx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file') }}
                </b-button>
              </a>
              <br />
              <b-button :disabled="disabledbool" icon-left="minus" @click="removedFile('scan_no_duna_dx')">
                {{ $translate('remove_file') }}
              </b-button>
            </div>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalScanNoDUDx = false">
            {{ $translate('close') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalGrapSx" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('grap') }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field :label="$translate('grap')">
            <b-field
              v-if="order.attachmentflag['grap_sx'] == null || order.attachmentflag['grap_sx'] == 0"
              class="file"
              :type="{ 'is-danger': errors.has('grap_sx') }"
              :message="errors.first('grap_sx')"
            >
              <b-upload
                v-model="order.attachment['grap_sx']"
                :disabled="disabledbool"
                :name="'grap_sx'"
                accept="image/*,application/pdf"
              >
                <a class="button is-primary" :disabled="disabledbool">
                  <b-icon icon="upload" />
                  <span>{{ $translate('upload_button') }}</span>
                </a>
              </b-upload>
              <span v-if="order.attachment['grap_sx']" class="file-name">
                {{ order.attachment['grap_sx'].name }}
              </span>
              <b-button
                :disabled="!order.attachment['grap_sx']"
                icon-left="minus"
                class="is-danger"
                @click="removedFile('grap_sx')"
              >
                {{ $translate('remove_file') }}
              </b-button>
            </b-field>
            <div v-else>
              <a target="_blank" :href="order.attachment['grap_sx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file') }}
                </b-button>
              </a>
              <br />
              <b-button :disabled="disabledbool" icon-left="minus" @click="removedFile('grap_sx')">
                {{ $translate('remove_file') }}
              </b-button>
            </div>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalGrapSx = false">
            {{ $translate('close') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalGrapDx" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('grap') }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field :label="$translate('grap')">
            <b-field
              v-if="order.attachmentflag['grap_dx'] == null || order.attachmentflag['grap_dx'] == 0"
              class="file"
              :type="{ 'is-danger': errors.has('grap_dx') }"
              :message="errors.first('grap_dx')"
            >
              <b-upload
                v-model="order.attachment['grap_dx']"
                :disabled="disabledbool"
                :name="'grap_dx'"
                accept="image/*,application/pdf"
              >
                <a class="button is-primary" :disabled="disabledbool">
                  <b-icon icon="upload" />
                  <span>{{ $translate('upload_button') }}</span>
                </a>
              </b-upload>
              <span v-if="order.attachment['grap_dx']" class="file-name">
                {{ order.attachment['grap_dx'].name }}
              </span>
              <b-button
                :disabled="!order.attachment['grap_dx']"
                icon-left="minus"
                class="is-danger"
                @click="removedFile('grap_dx')"
              >
                {{ $translate('remove_file') }}
              </b-button>
            </b-field>
            <div v-else>
              <a target="_blank" :href="order.attachment['grap_dx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file') }}
                </b-button>
              </a>
              <br />
              <b-button :disabled="disabledbool" icon-left="minus" @click="removedFile('grap_dx')">
                {{ $translate('remove_file') }}
              </b-button>
            </div>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalGrapDx = false">
            {{ $translate('close') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalAttachSx" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('attach') }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field :label="$translate('attach')">
            <b-field
              v-if="order.attachmentflag['attach_sx'] == null || order.attachmentflag['attach_sx'] == 0"
              class="file"
              :type="{ 'is-danger': errors.has('attach_sx') }"
              :message="errors.first('attach_sx')"
            >
              <!--<b-upload
                v-model="order.attachment['attach_sx']"
                :disabled="disabledbool"
                :name="'attach_sx'"
                accept="application/pdf,application/zip,application/rar,image/*"
                @input="attachmentSxUpdated()"
              >-->
              <b-upload
                v-model="order.attachment['attach_sx']"
                :disabled="disabledbool"
                :name="'attach_sx'"
                @input="attachmentSxUpdated()"
              >
                <a class="button is-primary" :disabled="disabledbool">
                  <b-icon icon="upload" />
                  <span>{{ $translate('upload_button') }}</span>
                </a>
              </b-upload>
              <span v-if="order.attachment['attach_sx']" class="file-name">
                {{ order.attachment['attach_sx'].name }}
              </span>
              <b-button
                :disabled="!order.attachment['attach_sx']"
                icon-left="minus"
                class="is-danger"
                @click="removedFile('attach_sx')"
              >
                {{ $translate('remove_file') }}
              </b-button>
            </b-field>
            <div v-else>
              <a target="_blank" :href="order.attachment['attach_sx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file') }}
                </b-button>
              </a>
              <br />
              <b-button :disabled="disabledbool" icon-left="minus" @click="removedFile('attach_sx')">
                {{ $translate('remove_file') }}
              </b-button>
            </div>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalAttachSx = false">
            {{ $translate('close') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="isComponentModalAttachDx" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('attach') }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field :label="$translate('attach')">
            <b-field
              v-if="order.attachmentflag['attach_dx'] == null || order.attachmentflag['attach_dx'] == 0"
              class="file"
              :type="{ 'is-danger': errors.has('attach_dx') }"
              :message="errors.first('attach_dx')"
            >
              <b-upload v-model="order.attachment['attach_dx']" :disabled="disabledbool" :name="'attach_dx'">
                <a class="button is-primary" :disabled="disabledbool">
                  <b-icon icon="upload" />
                  <span>{{ $translate('upload_button') }}</span>
                </a>
              </b-upload>
              <span v-if="order.attachment['attach_dx']" class="file-name">
                {{ order.attachment['attach_dx'].name }}
              </span>
              <b-button
                :disabled="!order.attachment['attach_dx']"
                icon-left="minus"
                class="is-danger"
                @click="removedFile('attach_dx')"
              >
                {{ $translate('remove_file') }}
              </b-button>
            </b-field>
            <div v-else>
              <a target="_blank" :href="order.attachment['attach_dx']">
                <b-button icon-left="file">
                  {{ $translate('link_to_file') }}
                </b-button>
              </a>
              <br />
              <b-button :disabled="disabledbool" icon-left="minus" @click="removedFile('attach_dx')">
                {{ $translate('remove_file') }}
              </b-button>
            </div>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalAttachDx = false">
            {{ $translate('close') }}
          </button>
        </footer>
      </div>
    </b-modal>

    <hr class="green" />
    <h3 class="subtitle green has-text-weight-bold" @click="footMeasurementsVisible = !footMeasurementsVisible">
      {{ $translate('footmeasurements') }}
      <b-icon :icon="!footMeasurementsVisible ? 'menu-down' : 'menu-up'"> </b-icon>
    </h3>
    <b-collapse :open="footMeasurementsVisible">
      <div class="columns">
        <div class="column" style="position: relative; height: 400px">
          <div class="columns">
            <div class="column is-12">
              <div class="columns is-mobile">
                <div class="column is-2">
                  <b-tooltip
                    type="is-dark"
                    position="is-right"
                    :label="$translate('copy_dx_in_sx') | capitalize"
                    multilined
                  >
                    <a
                      class="button is-primary"
                      :disabled="order.pair !== 'both' || disabledbool"
                      @click="copyhighlowdxinsx()"
                    >
                      <b-icon icon="content-copy" />
                    </a>
                  </b-tooltip>
                </div>
                <div class="column is-10">
                  <h3 class="subtitle green">
                    {{ $translate('left_foot') | uppercase }}
                  </h3>
                </div>
              </div>
            </div>
            <div class="column is-12">
              <img
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/foot_sx.png"
              />
              <img
                v-show="images['circ_ankle_sx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_Caviglia_SX_BOLD.png"
              />
              <img
                v-show="images['circ_neck_sx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_Collo_SX_BOLD.png"
              />
              <img
                v-show="images['circ_leg_sx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_Gamba_SX_BOLD.png"
              />
              <img
                v-show="images['high_ankle_sx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_H_Caviglia_SX_BOLD.png"
              />
              <img
                v-show="images['high_fings_sx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_H_Dita_SX_BOLD.png"
              />
              <img
                v-show="images['high_leg_sx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_H_Gamba_SX_BOLD.png"
              />
              <img
                v-show="images['high_heel_sx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_H_Tacco_SX_BOLD.png"
              />
              <img
                v-show="images['high_tom_sx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_H_TermTomaia_SX_BOLD.png"
              />
              <img
                v-show="images['foot_long_sx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_Lungh_Piede_SX_BOLD.png"
              />
              <img
                v-show="images['circ_meta_sx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_Metatarsi_SX_BOLD.png"
              />
              <img
                v-show="images['circ_past_sx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_Passata_SX_BOLD.png"
              />
              <img
                v-show="images['circ_retro_meta_sx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_RetroMetatarsi_SX_BOLD.png"
              />
              <img
                v-show="images['circ_end_tom_sx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_TermTomaia_SX_BOLD.png"
              />
            </div>
          </div>
        </div>
        <div class="column is-6">
          <table class="bordered-table static">
            <tr v-for="variant in $highlowmeasu" :key="variant.key">
              <template v-for="x in ['_sx', 'center', '_dx']">
                <td :key="x">
                  <strong v-if="x == 'center'">{{ $translate(variant.key) }}</strong>
                  <b-field v-else :key="x" :type="{ 'is-danger': errors.has(variant.key + x) }">
                    <b-input
                      v-model="order.footmeasurements[variant.key + x]"
                      v-validate="{
                        min_value: variant.key == 'high_heel' ? '-999' : '1',
                        max_value: variant.key == 'high_heel' ? '999' : false,
                        required:
                          (order.orderTypeMain == 'measurements' || order.orderTypeMain == 'digitalMeasurements') &&
                          //order.orderTypeVariant != 'card2' &&
                          order.orderTypeVariant != 'formproj' &&
                          ((order.pair !== 'right' &&
                            order.footmeasurements.c_pair != 'dx_c_pa' &&
                            variant.key == 'foot_long' &&
                            x == '_sx') ||
                            (order.pair !== 'left' &&
                              order.footmeasurements.c_pair != 'sx_c_pa' &&
                              variant.key == 'foot_long' &&
                              x == '_dx') ||
                            (order.pair !== 'right' &&
                              order.footmeasurements.c_pair != 'dx_c_pa' &&
                              variant.key == 'circ_meta' &&
                              x == '_sx') ||
                            (order.pair !== 'left' &&
                              order.footmeasurements.c_pair != 'sx_c_pa' &&
                              variant.key == 'circ_meta' &&
                              x == '_dx') ||
                            (order.pair !== 'right' &&
                              order.footmeasurements.c_pair != 'dx_c_pa' &&
                              variant.key == 'circ_neck' &&
                              x == '_sx') ||
                            (order.pair !== 'left' &&
                              order.footmeasurements.c_pair != 'sx_c_pa' &&
                              variant.key == 'circ_neck' &&
                              x == '_dx') ||
                            (order.pair !== 'right' &&
                              order.footmeasurements.c_pair != 'dx_c_pa' &&
                              variant.key == 'high_heel' &&
                              x == '_sx') ||
                            (order.pair !== 'left' &&
                              order.footmeasurements.c_pair != 'sx_c_pa' &&
                              variant.key == 'high_heel' &&
                              x == '_dx') ||
                            //(order.footmeasurements.c_pair != 'dx_c_pa' &&
                            //variant.key == 'circ_past' &&
                            //x == '_sx') ||
                            //(order.footmeasurements.c_pair != 'sx_c_pa' &&
                            //variant.key == 'circ_past' &&
                            //x == '_dx') ||
                            (order.shoeType == 'high' &&
                              ((order.footmeasurements.c_pair != 'dx_c_pa' &&
                                variant.key == 'circ_leg' &&
                                x == '_sx') ||
                                (order.footmeasurements.c_pair != 'sx_c_pa' &&
                                  variant.key == 'circ_leg' &&
                                  x == '_dx') ||
                                (order.footmeasurements.c_pair != 'dx_c_pa' &&
                                  variant.key == 'high_leg' &&
                                  x == '_sx') ||
                                (order.footmeasurements.c_pair != 'sx_c_pa' &&
                                  variant.key == 'high_leg' &&
                                  x == '_dx')))),
                      }"
                      type="number"
                      :disabled="
                        (x == '_dx' && order.pair == 'left') ||
                          (x == '_sx' && order.pair == 'right') ||
                          disabledbool ||
                          (order.shoeType == 'high' && !variant.high) ||
                          (order.shoeType == 'low' && !variant.low) ||
                          (order.orderTypeVariant == 'formplusplant' && order.shoeType == 'low') ||
                          (order.orderTypeVariant == 'form' && order.shoeType == 'low') ||
                          (order.orderTypeVariant == 'formplusplant' &&
                            order.shoeType == 'high' &&
                            variant.key != 'high_leg' &&
                            variant.key != 'circ_leg' &&
                            variant.key != 'high_tom' &&
                            variant.key != 'circ_end_tom') ||
                          (order.orderTypeVariant == 'form' &&
                            order.shoeType == 'high' &&
                            variant.key != 'high_leg' &&
                            variant.key != 'circ_leg' &&
                            variant.key != 'high_tom' &&
                            variant.key != 'circ_end_tom')
                      "
                      :name="variant.key + x"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      step="1"
                      @input="checkValue()"
                      @focus="
                        images[variant.key + x] = true
                        $forceUpdate()
                      "
                      @blur="
                        images[variant.key + x] = false
                        onMeasurementsBlur()
                        $forceUpdate()
                      "
                    />
                  </b-field>
                </td>
              </template>
            </tr>
            <tr>
              <td>
                <b-checkbox
                  v-model="order.footmeasurements.block_F_E_sx"
                  :disabled="order.pair == 'right' || disabledbool"
                />
              </td>
              <td>
                <strong>{{ $translate('block_F_E') | capitalize }}</strong>
              </td>
              <td>
                <b-checkbox
                  v-model="order.footmeasurements.block_F_E_dx"
                  :disabled="order.pair == 'left' || disabledbool"
                />
              </td>
            </tr>

            <tr>
              <td>
                <b-checkbox
                  v-model="order.footmeasurements.block_P_S_sx"
                  :disabled="order.pair == 'right' || disabledbool"
                />
              </td>

              <td>
                <strong>{{ $translate('block_P_S') | capitalize }}</strong>
              </td>
              <td>
                <b-checkbox
                  v-model="order.footmeasurements.block_P_S_dx"
                  :disabled="order.pair == 'left' || disabledbool"
                />
              </td>
            </tr>
          </table>
        </div>
        <div class="column" style="position: relative; height: 400px">
          <div class="columns">
            <div class="column is-12">
              <div class="columns is-mobile">
                <div class="column is-10">
                  <h3 class="subtitle green has-text-right">
                    {{ $translate('right_foot') | uppercase }}
                  </h3>
                </div>
                <div class="column is-2">
                  <b-tooltip
                    type="is-dark"
                    position="is-left"
                    :label="$translate('copy_sx_in_dx') | capitalize"
                    multilined
                  >
                    <a
                      class="button is-primary"
                      :disabled="order.pair !== 'both' || disabledbool"
                      @click="copyhighlowsxindx()"
                    >
                      <b-icon icon="content-copy" />
                    </a>
                  </b-tooltip>
                </div>
              </div>
            </div>
            <div class="column is-12">
              <img
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/foot_dx.png"
              />
              <img
                v-show="images['circ_ankle_dx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_Caviglia_DX_BOLD.png"
              />
              <img
                v-show="images['circ_neck_dx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_Collo_DX_BOLD.png"
              />
              <img
                v-show="images['circ_leg_dx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_Gamba_DX_BOLD.png"
              />
              <img
                v-show="images['high_ankle_dx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_H_Caviglia_DX_BOLD.png"
              />
              <img
                v-show="images['high_fings_dx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_H_Dita_DX_BOLD.png"
              />
              <img
                v-show="images['high_leg_dx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_H_Gamba_DX_BOLD.png"
              />
              <img
                v-show="images['high_heel_dx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_H_Tacco_DX_BOLD.png"
              />
              <img
                v-show="images['high_tom_dx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_H_TermTomaia_DX_BOLD.png"
              />
              <img
                v-show="images['foot_long_dx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_Lungh_Piede_DX_BOLD.png"
              />
              <img
                v-show="images['circ_meta_dx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_Metatarsi_DX_BOLD.png"
              />
              <img
                v-show="images['circ_past_dx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_Passata_DX_BOLD.png"
              />
              <img
                v-show="images['circ_retro_meta_dx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_RetroMetatarsi_DX_BOLD.png"
              />
              <img
                v-show="images['circ_end_tom_dx']"
                style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
                src="@/assets/images/bold/FWW_TermTomaia_DX_BOLD.png"
              />
            </div>
          </div>
        </div>
      </div>
    </b-collapse>

    <b-collapse v-if="!isSimplified" class="card" aria-id="contentIdForm" :open="false">
      <div slot="trigger" slot-scope="props" class="card-header" role="button" aria-controls="contentIdForm">
        <p class="card-header-title">
          {{ $translate('spec_measure_form') }}
        </p>
        <a class="card-header-icon">
          <b-icon :icon="props.open ? 'menu-up' : 'menu-down'" />
        </a>
      </div>
      <div class="card-content">
        <div class="content">
          <div class="columns">
            <div class="column is-3">
              <b-field :label="$translate('c_pair') | capitalize" horizontal>
                <b-select
                  v-model="order.footmeasurements['c_pair']"
                  :disabled="disabledbool"
                  :name="'c_pair'"
                  :placeholder="$translate('placeholder_select')"
                  @input="$forceUpdate()"
                >
                  <option value="not_spec" checked>
                    {{ $translate('not_spec') }}
                  </option>
                  <option v-if="order.pair === 'both'" value="com_c_pa">
                    {{ $translate('com_c_pa') }}
                  </option>
                  <option v-if="order.pair !== 'left'" value="dx_c_pa">
                    {{ $translate('dx_c_pa') }}
                  </option>
                  <option v-if="order.pair !== 'right'" value="sx_c_pa">
                    {{ $translate('sx_c_pa') }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-9">
              <div class="columns is-mobile">
                <div class="column is-1 has-text-right">
                  <b-icon icon="alert" type="is-danger" style="font-size: 35px" />
                </div>
                <div class="column is-11">
                  <span class="has-text-danger">{{ $translate('alert_spec_measu_form') }}</span>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <template
            v-if="
              order.footmeasurements['c_pair'] == 'com_c_pa' ||
                order.footmeasurements['c_pair'] == 'sx_c_pa' ||
                order.footmeasurements['c_pair'] == 'dx_c_pa'
            "
          >
            <div class="columns is-multiline">
              <div class="column is-two-fifths">
                <template
                  v-if="order.footmeasurements['c_pair'] == 'com_c_pa' || order.footmeasurements['c_pair'] == 'sx_c_pa'"
                >
                  <div class="columns is-multiline">
                    <div class="column title-block">
                      {{ $translate('measure_text') | capitalize }}
                    </div>
                    <div class="column title-block">
                      {{ $translate('foot') | capitalize }}
                    </div>
                    <div class="column title-block">
                      {{ $translate('form') | capitalize }}
                    </div>
                    <div class="column is-one-fifth" />
                  </div>
                </template>
              </div>

              <div class="column is-one-fifth" style="has-text-centered" />
              <div class="column is-two-fifths">
                <template
                  v-if="order.footmeasurements['c_pair'] == 'com_c_pa' || order.footmeasurements['c_pair'] == 'dx_c_pa'"
                >
                  <div class="columns is-multiline">
                    <div class="column is-one-fifth" />

                    <div class="column title-block">
                      {{ $translate('measure_text') | capitalize }}
                    </div>
                    <div class="column title-block">
                      {{ $translate('foot') | capitalize }}
                    </div>
                    <div class="column title-block">
                      {{ $translate('form') | capitalize }}
                    </div>
                  </div>
                </template>
              </div>
              <template v-for="variant in $formames">
                <div :key="variant.key + '_first'" class="column is-two-fifths">
                  <template
                    v-if="
                      order.footmeasurements['c_pair'] == 'com_c_pa' || order.footmeasurements['c_pair'] == 'sx_c_pa'
                    "
                  >
                    <div class="columns">
                      <div class="column has-text-weight-semibold">
                        {{ $translate(variant.key) | capitalize }}
                      </div>
                      <div class="column">
                        <b-input
                          v-model="order.footmeasurements[variant.key + 'foot_sx']"
                          type="number"
                          step="1"
                          :name="variant.key + 'foot_sx'"
                          :disabled="true"
                          :placeholder="$translate('placeholder_numeric_mm')"
                          custom-class="has-text-centered"
                          @input="checkValue()"
                        />
                      </div>
                      <div class="column">
                        <b-input
                          v-model="order.footmeasurements[variant.key + 'plan_sx']"
                          type="number"
                          step="1"
                          :name="variant.key + 'plan_sx'"
                          :disabled="
                            order.pair === 'right' ||
                              disabledbool ||
                              order.orderTypeVariant == 'formplusplant' ||
                              order.orderTypeVariant == 'form'
                          "
                          :placeholder="$translate('placeholder_numeric_mm')"
                          custom-class="has-text-centered"
                          @input="checkValue()"
                          @blur="setShoeMeasure()"
                        />
                      </div>
                      <div class="column is-one-fifth" />
                    </div>
                  </template>
                </div>

                <div
                  :key="variant.key"
                  class="
                    column
                    is-one-fifth
                    has-text-centered
                    bordered-left bordered-right
                    fiftyimage
                  "
                >
                  <template
                    v-if="
                      order.footmeasurements['c_pair'] == 'com_c_pa' ||
                        order.footmeasurements['c_pair'] == 'sx_c_pa' ||
                        order.footmeasurements['c_pair'] == 'dx_c_pa'
                    "
                  >
                    <img v-if="variant.key == 'f_long_form'" src="@/assets/images/definite/Lunghezza180_ok.png" />
                    <img v-else-if="variant.key == 'f_large_form'" src="@/assets/images/definite/Larghezza180_ok.png" />
                    <img v-else-if="variant.key == 'f_high_point'" src="@/assets/images/definite/H-Punta180_ok.png" />
                    <img v-else-if="variant.key == 'f_circ_meta'" src="@/assets/images/definite/Metatarsi180_ok.png" />
                    <img
                      v-else-if="variant.key == 'f_circ_retrometa'"
                      src="@/assets/images/definite/RetroMetatarsi180_ok.png"
                    />
                    <img v-else-if="variant.key == 'f_circ_neck'" src="@/assets/images/definite/Collo180_ok.png" />
                    <img v-else-if="variant.key == 'f_circ_pass'" src="@/assets/images/definite/Passata180_ok.png" />
                    <img v-else-if="variant.key == 'f_circ_mall'" src="@/assets/images/definite/C-Malleoli180_ok.png" />
                    <img
                      v-else-if="variant.key == 'f_circ_term_tom'"
                      src="@/assets/images/definite/T-Tomaia180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_high_term_tom'"
                      src="@/assets/images/definite/H-Tomaia180_ok.png"
                    />
                    <img v-else-if="variant.key == 'f_high_tot'" src="@/assets/images/definite/H-Forma180_ok.png" />
                    <img v-else src="https://via.placeholder.com/100x50" />
                  </template>
                </div>
                <div :key="variant.key + '_second'" class="column is-two-fifths">
                  <template
                    v-if="
                      order.footmeasurements['c_pair'] == 'com_c_pa' || order.footmeasurements['c_pair'] == 'dx_c_pa'
                    "
                  >
                    <div class="columns">
                      <div class="column is-one-fifth" />

                      <div class="column has-text-weight-semibold">
                        {{ $translate(variant.key) | capitalize }}
                      </div>
                      <div class="column">
                        <b-input
                          v-model="order.footmeasurements[variant.key + 'foot_dx']"
                          type="number"
                          :disabled="true"
                          step="1"
                          :name="variant.key + 'foot_dx'"
                          :placeholder="$translate('placeholder_numeric_mm')"
                          custom-class="has-text-centered"
                          @input="checkValue()"
                        />
                      </div>
                      <div class="column">
                        <b-input
                          v-model="order.footmeasurements[variant.key + 'plan_dx']"
                          type="number"
                          step="1"
                          :name="variant.key + 'plan_dx'"
                          :disabled="
                            order.pair === 'left' ||
                              disabledbool ||
                              order.orderTypeVariant == 'formplusplant' ||
                              order.orderTypeVariant == 'form'
                          "
                          :placeholder="$translate('placeholder_numeric_mm')"
                          custom-class="has-text-centered"
                          @input="checkValue()"
                          @blur="setShoeMeasure()"
                        />
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </template>

          <!--<div class="columns">
            <div class="column is-6">
              <div
                class="columns is-multiline"
                v-if="
                  order.footmeasurements['c_pair'] == 'com_c_pa' ||
                    order.footmeasurements['c_pair'] == 'sx_c_pa'
                "
              >
                <div class="column is-3"></div>
                <div class="column is-3 bordered graybg">
                  {{ $translate("measure_text") | capitalize }}
                </div>
                <div class="column is-3 bordered graybg">
                  {{ $translate("left_foot") | capitalize }}
                </div>
                <div class="column is-3 bordered graybg">
                  {{ $translate("form") | capitalize }}
                </div>
                <template v-for="variant in $formames">
                  <div class="column is-3 imagecell" :key="variant.key + '_sx'">
                    <img
                      v-if="variant.key == 'f_long_form'"
                      src="@/assets/images/definite/Lunghezza180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_large_form'"
                      src="@/assets/images/definite/Larghezza180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_high_point'"
                      src="@/assets/images/definite/H-Punta180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_circ_meta'"
                      src="@/assets/images/definite/Metatarsi180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_circ_retrometa'"
                      src="@/assets/images/definite/RetroMetatarsi180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_circ_neck'"
                      src="@/assets/images/definite/Collo180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_circ_pass'"
                      src="@/assets/images/definite/Passata180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_circ_mall'"
                      src="@/assets/images/definite/C-Malleoli180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_circ_term_tom'"
                      src="@/assets/images/definite/T-Tomaia180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_high_term_tom'"
                      src="@/assets/images/definite/H-Tomaia180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_high_tot'"
                      src="@/assets/images/definite/H-Forma180_ok.png"
                    />
                    <img v-else src="https://via.placeholder.com/100x50" />
                  </div>
                  <div
                    class="column is-3 bordered"
                    :key="variant.key + '_sx' + '_a'"
                  >
                    {{ $translate(variant.key) | capitalize }}
                  </div>
                  <div
                    class="column is-3 bordered"
                    :key="variant.key + '_sx' + '_b'"
                  >
                    <b-input
                      @input="checkValue()"
                      type="number"
                      step="1"
                      :name="variant.key + 'foot_sx'"
                      v-model="order.footmeasurements[variant.key + 'foot_sx']"
                      :disabled="true"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      custom-class="has-text-centered"
                    ></b-input>
                  </div>
                  <div
                    class="column is-3 bordered"
                    :key="variant.key + '_sx' + '_c'"
                  >
                    <b-input
                      type="number"
                      @input="checkValue()"
                      step="1"
                      :name="variant.key + 'plan_sx'"
                      v-model="order.footmeasurements[variant.key + 'plan_sx']"
                      :disabled="disabledbool"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      custom-class="has-text-centered"
                    ></b-input>
                  </div>
                </template>
              </div>
            </div>
            <div class="column is-6">
              <div
                class="columns is-multiline"
                v-if="
                  order.footmeasurements['c_pair'] == 'com_c_pa' ||
                    order.footmeasurements['c_pair'] == 'dx_c_pa'
                "
              >
                <div class="column is-3"></div>
                <div class="column is-3 bordered graybg">
                  {{ $translate("measure_text") | capitalize }}
                </div>
                <div class="column is-3 bordered graybg">
                  {{ $translate("right_foot") | capitalize }}
                </div>
                <div class="column is-3 bordered graybg">
                  {{ $translate("form") | capitalize }}
                </div>
                <template v-for="variant in $formames">
                  <div
                    class="column is-3 imagecell"
                    :key="variant.key + '_dx' + '_a'"
                  >
                    <img
                      v-if="variant.key == 'f_long_form'"
                      src="@/assets/images/definite/Lunghezza180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_large_form'"
                      src="@/assets/images/definite/Larghezza180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_high_point'"
                      src="@/assets/images/definite/H-Punta180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_circ_meta'"
                      src="@/assets/images/definite/Metatarsi180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_circ_retrometa'"
                      src="@/assets/images/definite/RetroMetatarsi180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_circ_neck'"
                      src="@/assets/images/definite/Collo180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_circ_pass'"
                      src="@/assets/images/definite/Passata180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_circ_mall'"
                      src="@/assets/images/definite/C-Malleoli180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_circ_term_tom'"
                      src="@/assets/images/definite/T-Tomaia180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_high_term_tom'"
                      src="@/assets/images/definite/H-Tomaia180_ok.png"
                    />
                    <img
                      v-else-if="variant.key == 'f_high_tot'"
                      src="@/assets/images/definite/H-Forma180_ok.png"
                    />
                    <img v-else src="https://via.placeholder.com/100x50" />
                  </div>
                  <div
                    class="column is-3 bordered"
                    :key="variant.key + '_dx' + '_b'"
                  >
                    {{ $translate(variant.key) | capitalize }}
                  </div>
                  <div
                    class="column is-3 bordered"
                    :key="variant.key + '_dx' + '_c'"
                  >
                    <b-input
                      type="number"
                      @input="checkValue()"
                      :disabled="true"
                      step="1"
                      :name="variant.key + 'foot_dx'"
                      v-model="order.footmeasurements[variant.key + 'foot_dx']"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      custom-class="has-text-centered"
                    ></b-input>
                  </div>
                  <div
                    class="column is-3 bordered"
                    :key="variant.key + '_dx' + '_d'"
                  >
                    <b-input
                      type="number"
                      @input="checkValue()"
                      step="1"
                      :name="variant.key + 'plan_dx'"
                      v-model="order.footmeasurements[variant.key + 'plan_dx']"
                      :disabled="disabledbool"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      custom-class="has-text-centered"
                    ></b-input>
                  </div>
                </template>
              </div>
            </div>
          </div>-->
        </div>
        <h3 class="subtitle green">
          {{ $translate('scar_form') | capitalize }}
        </h3>
        <div class="columns">
          <div class="column is-6">
            <b-field :label="$translate('scari_retro') | capitalize" horizontal>
              <b-select
                v-model="order.footmeasurements['scari_retro_sx']"
                :disabled="order.pair === 'right' || disabledbool"
                :placeholder="$translate('placeholder_select')"
              >
                <option value="nobody">
                  {{ $translate('nobody') }}
                </option>
                <option value="scar_calc">
                  {{ $translate('scar_calc') }}
                </option>
              </b-select>
              <b-input
                v-model="order.footmeasurements['scari_retro_sx_num']"
                :disabled="order.pair === 'right' || disabledbool"
                @input="checkValue()"
              />
            </b-field>

            <b-field :label="$translate('scari_meso') | capitalize" horizontal>
              <b-select
                v-model="order.footmeasurements['scari_meso_sx']"
                :disabled="order.pair === 'right' || disabledbool"
                :placeholder="$translate('placeholder_select')"
              >
                <option value="nobody">
                  {{ $translate('nobody') }}
                </option>
                <option value="scar_meta">
                  {{ $translate('scar_meta') }}
                </option>
                <option value="barr_retro">
                  {{ $translate('barr_retro') }}
                </option>
              </b-select>
              <b-input
                v-model="order.footmeasurements['scari_meso_sx_num']"
                :disabled="order.pair === 'right' || disabledbool"
                @input="checkValue()"
              />
            </b-field>
          </div>

          <div class="column is-6">
            <b-field :label="$translate('scari_retro') | capitalize" horizontal>
              <b-select
                v-model="order.footmeasurements['scari_retro_dx']"
                :disabled="order.pair === 'left' || disabledbool"
                :placeholder="$translate('placeholder_select')"
              >
                <option value="nobody">
                  {{ $translate('nobody') }}
                </option>
                <option value="scar_calc">
                  {{ $translate('scar_calc') }}
                </option>
              </b-select>
              <b-input
                v-model="order.footmeasurements['scari_retro_dx_num']"
                :disabled="order.pair === 'left' || disabledbool"
                @input="checkValue()"
              />
            </b-field>

            <b-field :label="$translate('scari_meso') | capitalize" horizontal>
              <b-select
                v-model="order.footmeasurements['scari_meso_dx']"
                :disabled="order.pair === 'left' || disabledbool"
                :placeholder="$translate('placeholder_select')"
              >
                <option value="nobody">
                  {{ $translate('nobody') }}
                </option>
                <option value="scar_meta">
                  {{ $translate('scar_meta') }}
                </option>
                <option value="barr_retro">
                  {{ $translate('barr_retro') }}
                </option>
              </b-select>
              <b-input
                v-model="order.footmeasurements['scari_meso_dx_num']"
                :disabled="order.pair === 'left' || disabledbool"
                @input="checkValue()"
              />
            </b-field>
          </div>
        </div>
        <!--<b-field grouped>
          <b-field
            :label="$translate('last_in') | capitalize"
            horizontal
            expanded
          >
            <b-checkbox
              v-model="order.footmeasurements['last_in']"
              :disabled="disabledbool"
            >
            </b-checkbox>
          </b-field>
          <b-field
            :label="$translate('without_junction') | capitalize"
            horizontal
            expanded
          >
            <b-checkbox
              @input="changeWithoutJunction()"
              :disabled="disabledbool"
              v-model="order.footmeasurements['without_junction']"
            >
            </b-checkbox>
          </b-field>
        </b-field>-->

        <!--<template v-for="optio in $stylepoint">
          <div class="columns is-multiline" :key="optio.key">
            <div class="column is-6">
              <b-field :label="$translate(optio.key) | capitalize" horizontal>
                <b-select
                  :disabled="disabledbool"
                  :name="optio.key"
                  v-model="order.footmeasurements[optio.key]"
                  :placeholder="$translate('placeholder_select')"
                >
                  <template v-for="variant in optio.variant">
                    <option :key="variant.key" :value="variant.key">{{
                      $translate(variant.key)
                    }}</option>
                  </template>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field
                :label="$translate('last_in') | capitalize"
                horizontal
                v-if="optio.key == 'c_point'"
              >
                <b-checkbox
                  v-model="order.footmeasurements['last_in']"
                  :disabled="disabledbool"
                >
                </b-checkbox>
              </b-field>
              <b-field
                :label="$translate('without_junction') | capitalize"
                horizontal
                v-if="optio.key == 'c_style'"
              >
                <b-checkbox
                  @input="changeWithoutJunction()"
                  :disabled="disabledbool"
                  v-model="order.footmeasurements['without_junction']"
                >
                </b-checkbox>
              </b-field>
            </div>
          </div>
        </template>-->
      </div>
    </b-collapse>
    <hr class="green" />
    <h3 class="subtitle green">
      {{ $translate('form_style') }}
    </h3>
    <b-field grouped>
      <template v-for="optio in $stylepoint">
        <b-field :key="optio.key" :label="$translate(optio.key) | capitalize" horizontal expanded>
          <b-select
            v-model="order.footmeasurements[optio.key]"
            :disabled="disabledbool"
            :name="optio.key"
            :placeholder="$translate('placeholder_select')"
          >
            <template v-for="variant in optio.variant">
              <option :key="variant.key" :value="variant.key">
                {{ $translate(variant.key) }}
              </option>
            </template>
          </b-select>
        </b-field>
      </template>
    </b-field>
    <hr class="green" />
    <div class="block">
      <h3 class="subtitle green" style="display: inline; padding-right: 30px">
        {{ $translate('plantare') }}
      </h3>
      <b-radio
        v-model="order.plan_realization"
        name="plan_realization"
        native-value="no_plantar"
        :disabled="disabledbool"
        @input="planRealizationChanged()"
      >
        {{ $translate('no_plantar') }}
      </b-radio>
      <b-radio
        v-model="order.plan_realization"
        name="plan_realization"
        native-value="reali_duna"
        :disabled="disabledbool"
        @input="planRealizationChanged()"
      >
        {{ $translate('reali_duna') }}
      </b-radio>
      <b-radio
        v-model="order.plan_realization"
        name="plan_realization"
        native-value="reali_proper"
        :disabled="disabledbool"
        @input="planRealizationChanged()"
      >
        {{ $translate('reali_proper') }}
      </b-radio>
    </div>
    <div v-if="order.plan_realization == 'reali_duna'">
      <div class="columns">
        <div class="column has-text-left">
          <div class="columns is-mobile">
            <div class="column is-1">
              <b-tooltip
                type="is-dark"
                position="is-right"
                :label="$translate('copy_dx_in_sx') | capitalize"
                multilined
              >
                <a
                  class="button is-primary"
                  :disabled="order.pair !== 'both' || disabledbool"
                  @click="copyplantaredxinsx()"
                >
                  <b-icon icon="content-copy" />
                </a>
              </b-tooltip>
            </div>
            <div class="column is-11">
              <h3 class="subtitle green">
                {{ $translate('left_foot') | uppercase }}
              </h3>
            </div>
          </div>
        </div>
        <div class="column has-text-right">
          <div class="columns is-mobile">
            <div class="column is-11">
              <h3 class="subtitle green">
                {{ $translate('right_foot') | uppercase }}
              </h3>
            </div>
            <div class="column is-1">
              <b-tooltip type="is-dark" position="is-left" :label="$translate('copy_sx_in_dx') | capitalize" multilined>
                <a
                  class="button is-primary"
                  :disabled="order.pair !== 'both' || disabledbool"
                  @click="copyplantaresxindx()"
                >
                  <b-icon icon="content-copy" />
                </a>
              </b-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <!-- TODO-->
        <!--<div class="column">
          <img src="@/assets/images/Plantare_RENDER_300x300_SX.png" />
        </div>-->
        <div class="column" style="position: relative">
          <img
            style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
            src="@/assets/images/FW_plantare_PNG/Plantare_RENDER_300x300_SX.png"
          />
          <img
            v-show="images['thick_cen_heel_sx']"
            style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
            src="@/assets/images/FW_plantare_PNG/Spess_Tacco_SX.png"
          />
          <img
            v-show="images['thick_pla_sx']"
            style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
            src="@/assets/images/FW_plantare_PNG/Spess_Pianta_SX.png"
          />
          <img
            v-show="images['thick_poi_sx']"
            style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
            src="@/assets/images/FW_plantare_PNG/Spess_Punta_SX.png"
          />
          <!--<img
          v-show="images['pla_til_heel_sx']"
          style="position:absolute;top:80;bottom:0;left:0;right:0;"
          src="@/assets/images/FW_plantare_PNG/FWW_H_Caviglia_DX_BOLD.png"
        />
        <img
          v-show="images['pla_til_poi_sx']"
          style="position:absolute;top:80;bottom:0;left:0;right:0;"
          src="@/assets/images/FW_plantare_PNG/FWW_H_Dita_DX_BOLD.png"
        />-->
          <img
            v-show="images['height_col_med_sx']"
            style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
            src="@/assets/images/FW_plantare_PNG/Avvolgenza_Med_SX.png"
          />
          <img
            v-show="images['height_col_lat_sx']"
            style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
            src="@/assets/images/FW_plantare_PNG/Avvolgenza_Lat_SX.png"
          />
        </div>
        <div class="column is-6">
          <table style="margin: 0; padding: 0; width: 100%" class="bordered-table static">
            <tr>
              <td>
                <b-checkbox
                  v-model="order.isDunaInsoleDisabledSx"
                  :true-value="false"
                  :false-value="true"
                  :disabled="order.pair === 'right' || disabledbool"
                  @input="resetDunaInsoleValues('_sx')"
                />
              </td>
              <td>
                <strong>{{ $translate('plan_realization') | capitalize }}</strong>
              </td>
              <td>
                <b-checkbox
                  v-model="order.isDunaInsoleDisabledDx"
                  :true-value="false"
                  :false-value="true"
                  :disabled="order.pair === 'left' || disabledbool"
                  @input="resetDunaInsoleValues('_dx')"
                />
              </td>
            </tr>
            <tr v-for="variant in $plantare" :key="variant.key">
              <template v-for="x in ['_sx', 'center', '_dx']">
                <td :key="x">
                  <strong v-if="x == 'center'">{{ $translate(variant.key) | capitalize }}</strong>
                  <b-field v-else :key="x" :type="{ 'is-danger': errors.has(variant.key + x) }">
                    <b-input
                      v-model="order.footmeasurements[variant.key + x]"
                      v-validate="{
                        required:
                          (order.pair !== 'right' &&
                            variant.key == 'thick_cen_heel' &&
                            !order.isDunaInsoleDisabledSx &&
                            x == '_sx') ||
                          (order.pair !== 'left' &&
                            variant.key == 'thick_cen_heel' &&
                            !order.isDunaInsoleDisabledDx &&
                            x == '_dx') ||
                          (order.pair !== 'right' &&
                            variant.key == 'thick_pla' &&
                            !order.isDunaInsoleDisabledSx &&
                            x == '_sx') ||
                          (order.pair !== 'left' &&
                            variant.key == 'thick_pla' &&
                            !order.isDunaInsoleDisabledDx &&
                            x == '_dx') ||
                          (order.pair !== 'right' &&
                            variant.key == 'thick_poi' &&
                            !order.isDunaInsoleDisabledSx &&
                            x == '_sx') ||
                          (order.pair !== 'left' &&
                            variant.key == 'thick_poi' &&
                            !order.isDunaInsoleDisabledDx &&
                            x == '_dx'),
                      }"
                      type="number"
                      step="1"
                      :disabled="
                        disabledbool ||
                          (x == '_sx' && order.isDunaInsoleDisabledSx) ||
                          (x == '_dx' && order.isDunaInsoleDisabledDx)
                      "
                      :name="variant.key + x"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="checkValue()"
                      @focus="
                        images[variant.key + x] = true
                        $forceUpdate()
                      "
                      @blur="
                        images[variant.key + x] = false
                        $forceUpdate()
                      "
                    />
                  </b-field>
                </td>
              </template>
            </tr>
          </table>
        </div>

        <div class="column" style="position: relative">
          <img
            style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
            src="@/assets/images/FW_plantare_PNG/Plantare_RENDER_300x300_DX.png"
          />
          <img
            v-show="images['thick_cen_heel_dx']"
            style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
            src="@/assets/images/FW_plantare_PNG/Spess_Tacco_DX.png"
          />
          <img
            v-show="images['thick_pla_dx']"
            style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
            src="@/assets/images/FW_plantare_PNG/Spess_Pianta_DX.png"
          />
          <img
            v-show="images['thick_poi_dx']"
            style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
            src="@/assets/images/FW_plantare_PNG/Spess_Punta_DX.png"
          />
          <!--<img
          v-show="images['pla_til_heel_dx']"
          style="position:absolute;top:80;bottom:0;left:0;right:0;"
          src="@/assets/images/FW_plantare_PNG/FWW_H_Caviglia_DX_BOLD.png"
        />
        <img
          v-show="images['pla_til_poi_dx']"
          style="position:absolute;top:80;bottom:0;left:0;right:0;"
          src="@/assets/images/FW_plantare_PNG/FWW_H_Dita_DX_BOLD.png"
        />-->
          <img
            v-show="images['height_col_med_dx']"
            style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
            src="@/assets/images/FW_plantare_PNG/Avvolgenza_Med_DX.png"
          />
          <img
            v-show="images['height_col_lat_dx']"
            style="position: absolute; top: 80; bottom: 0; left: 0; right: 0"
            src="@/assets/images/FW_plantare_PNG/Avvolgenza_Lat_DX.png"
          />
        </div>
      </div>

      <div class="columns">
        <div class="column is-6">
          <b-collapse class="card" aria-id="contentIdForsxplant" :open="false">
            <div
              slot="trigger"
              slot-scope="props"
              class="card-header"
              role="button"
              aria-controls="contentIdForsxplant"
            >
              <p class="card-header-title">
                {{ $translate('details_plan_costr') }}
              </p>
              <a class="card-header-icon">
                <b-icon :icon="props.open ? 'menu-up' : 'menu-down'" />
              </a>
            </div>
            <div class="card-content">
              <div class="content">
                <div class="block">
                  <b-tooltip
                    type="is-dark"
                    position="is-right"
                    :label="$translate('copy_dx_in_sx') | capitalize"
                    multilined
                  >
                    <a
                      class="button is-primary"
                      :disabled="order.pair !== 'both' || disabledbool"
                      @click="copyInsoleDetailsDxinSx()"
                    >
                      <b-icon icon="content-copy" />
                    </a>
                  </b-tooltip>
                  <template v-for="optio in $plantaremontaggio">
                    <div
                      v-show="(optio.key != 'fin_dess' && optio.key != 'pelotte') || see1sx"
                      :key="optio.key + '_sx'"
                      class="box"
                    >
                      <b-field
                        v-show="(optio.key != 'fin_dess' && optio.key != 'pelotte') || see1sx"
                        :key="optio.key + '_sx'"
                        :label="$translate(optio.key) | capitalize"
                        :type="{ 'is-danger': errors.has(optio.key + '_sx') }"
                        :message="errors.first(optio.key + '_sx')"
                        horizontal
                      >
                        <b-select
                          v-model="order.footmeasurements[optio.key + '_sx']"
                          v-validate="{ required: isInsoleInfoRequired(optio.key, 'sx') }"
                          :disabled="disabledbool || order.isDunaInsoleDisabledSx"
                          :name="optio.key + '_sx'"
                          :placeholder="$translate('placeholder_select')"
                        >
                          <!-- nooneSelected: (optio.key == 'plantar_type' && !order.isDunaInsoleDisabledSx) -->
                          <!-- SELECT MATERIALI -->
                          <template v-if="optio.material">
                            <option
                              v-if="optio.key != 'base_mat'"
                              :key="null"
                              :value="null"
                              :label="$translate('Noone')"
                            />
                            <option
                              v-for="optio in availablemat[optio.material]"
                              :key="optio.id"
                              :value="optio.id"
                              :label="$translateMaterial(optio)"
                            />
                          </template>
                          <!-- SELECT TIPO PLANTARI -->
                          <template v-else>
                            <option v-for="variant in optio.option" :key="variant.key" :value="variant.key">
                              {{ $translate(variant.key) }}
                            </option>
                          </template>
                        </b-select>
                        <template v-if="optio.key == 'plantar_type'">
                          <!--Qui prametro vero -->
                          <img
                            v-if="order.footmeasurements[optio.key + '_sx'] != null"
                            src="https://via.placeholder.com/100x100"
                            style="float: right"
                          />
                          <img v-else src="https://via.placeholder.com/100x100" style="float: right" />
                        </template>
                        <template v-else>
                          <img :src="getInsolePartImage(optio, 'sx')" class="insoleImage" alt="Material image" />
                        </template>
                      </b-field>
                      <b-field
                        v-if="isVariantVisible(optio, 'sx')"
                        :key="optio.key + 'var_sx'"
                        :label="$translate('variant') | capitalize"
                        :type="{ 'is-danger': errors.has(optio.key + 'var_sx') }"
                        :message="errors.first(optio.key + 'var_sx')"
                        horizontal
                      >
                        <b-select
                          v-model="order.footmeasurements[optio.key + 'var_sx']"
                          v-validate="{ required: isInsoleInfoRequired(optio.key, 'sx') }"
                          :disabled="disabledbool || order.isDunaInsoleDisabledSx"
                          :name="optio.key + 'var_sx'"
                          :placeholder="$translate('placeholder_select')"
                        >
                          <option
                            v-if="optio.key != 'base_mat'"
                            :key="null"
                            :value="null"
                            :label="$translate('Noone')"
                          />
                          <option
                            v-for="variant in availablemat[optio.material].find(
                              temp => temp.id == order.footmeasurements[optio.key + '_sx']
                            ).variants"
                            :key="variant.id"
                            :value="variant.id"
                            :label="variant.name"
                          />
                        </b-select>
                      </b-field>
                    </div>
                  </template>
                  <a v-if="!isSimplified" :class="{ linkred: see1sx }" @click="see1sx = !see1sx">
                    {{ $translate(see1sx ? 'hide_pelot_fin_dess' : 'show_pelot_fin_dess') | capitalize }}
                    <b-icon :icon="see1sx ? 'minus-circle' : 'plus-circle'" size="is-small" />
                  </a>

                  <template v-if="!isSimplified">
                    <br />
                    <br />
                    <br />
                    <a v-if="order.secondplantsx" class="linkred" @click="deleteAdditionalInsole('sx')">
                      {{ $translate('remove_plantar') | capitalize }}<b-icon icon="minus-circle" size="is-small"
                    /></a>

                    <a
                      v-else
                      @click="
                        order.secondplantsx = true
                        $forceUpdate()
                      "
                      >{{ $translate('add_plantar') | capitalize }}<b-icon icon="plus-circle" size="is-small"
                    /></a>
                  </template>
                  <br />
                  <template v-if="order.secondplantsx">
                    <template v-for="optio in $plantaremontaggio">
                      <div
                        v-if="optio.key != 'plantar_type'"
                        v-show="(optio.key != 'fin_dess' && optio.key != 'pelotte') || see2sx"
                        :key="optio.key + '_sx2'"
                        class="box"
                      >
                        <b-field
                          :key="optio.key + '_sx2'"
                          :label="$translate(optio.key) | capitalize"
                          :type="{ 'is-danger': errors.has(optio.key + '_sx2') }"
                          :message="errors.first(optio.key + '_sx2')"
                          horizontal
                        >
                          <b-select
                            v-model="order.footmeasurements[optio.key + '_sx2']"
                            v-validate="{ required: isInsoleInfoRequired(optio.key, 'sx2') }"
                            :disabled="disabledbool || order.isDunaInsoleDisabledSx"
                            :name="optio.key + '_sx2'"
                            :placeholder="$translate('placeholder_select')"
                          >
                            <template v-if="optio.material">
                              <option
                                v-if="optio.key != 'base_mat'"
                                :key="null"
                                :value="null"
                                :label="$translate('Noone')"
                              />
                              <option
                                v-for="optio in availablemat[optio.material]"
                                :key="optio.id"
                                :value="optio.id"
                                :label="$translateMaterial(optio)"
                              />
                            </template>
                          </b-select>
                          <template>
                            <img :src="getInsolePartImage(optio, 'sx2')" class="insoleImage" alt="Material image" />
                          </template>
                        </b-field>
                        <b-field
                          v-if="isVariantVisible(optio, 'sx2')"
                          :key="optio.key + 'var_sx2'"
                          :label="$translate('variant') | capitalize"
                          horizontal
                        >
                          <b-select
                            v-model="order.footmeasurements[optio.key + 'var_sx2']"
                            :disabled="disabledbool || order.isDunaInsoleDisabledSx"
                            :name="optio.key + 'var_sx2'"
                            :placeholder="$translate('placeholder_select')"
                          >
                            <option
                              v-if="optio.key != 'base_mat'"
                              :key="null"
                              :value="null"
                              :label="$translate('Noone')"
                            />
                            <option
                              v-for="variant in availablemat[optio.material].find(
                                temp => temp.id == order.footmeasurements[optio.key + '_sx2']
                              ).variants"
                              :key="variant.id"
                              :value="variant.id"
                              :label="variant.name"
                            />
                          </b-select>
                        </b-field>
                      </div>
                    </template>
                    <a :class="{ linkred: see2sx }" @click="see2sx = !see2sx">
                      {{ $translate(see2sx ? 'hide_pelot_fin_dess' : 'show_pelot_fin_dess') | capitalize }}
                      <b-icon :icon="see2sx ? 'minus-circle' : 'plus-circle'" size="is-small" />
                    </a>
                    <br />
                  </template>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
        <div class="column is-6">
          <b-collapse class="card" aria-id="contentIdForsxplant" :open="false">
            <div
              slot="trigger"
              slot-scope="props"
              class="card-header"
              role="button"
              aria-controls="contentIdForsxplant"
            >
              <p class="card-header-title">
                {{ $translate('details_plan_costr') }}
              </p>
              <a class="card-header-icon">
                <b-icon :icon="props.open ? 'menu-up' : 'menu-down'" />
              </a>
            </div>
            <div class="card-content">
              <div class="content">
                <div class="block">
                  <b-tooltip
                    type="is-dark"
                    position="is-right"
                    :label="$translate('copy_sx_in_dx') | capitalize"
                    multilined
                  >
                    <a
                      class="button is-primary"
                      :disabled="order.pair !== 'both' || disabledbool"
                      @click="copyInsoleDetailsSxinDx()"
                    >
                      <b-icon icon="content-copy" />
                    </a>
                  </b-tooltip>
                  <template v-for="optio in $plantaremontaggio">
                    <div
                      v-show="(optio.key != 'fin_dess' && optio.key != 'pelotte') || see1dx"
                      :key="optio.key + '_dx'"
                      class="box"
                    >
                      <b-field
                        v-show="(optio.key != 'fin_dess' && optio.key != 'pelotte') || see1dx"
                        :key="optio.key + '_dx'"
                        :label="$translate(optio.key) | capitalize"
                        :type="{ 'is-danger': errors.has(optio.key + '_dx') }"
                        :message="errors.first(optio.key + '_dx')"
                        horizontal
                      >
                        <b-select
                          v-model="order.footmeasurements[optio.key + '_dx']"
                          v-validate="{ required: isInsoleInfoRequired(optio.key, 'dx') }"
                          :disabled="disabledbool || order.isDunaInsoleDisabledDx"
                          :name="optio.key + '_dx'"
                          :placeholder="$translate('placeholder_select')"
                        >
                          <!-- SELECT MATERIALI -->
                          <template v-if="optio.material">
                            <option
                              v-if="optio.key != 'base_mat'"
                              :key="null"
                              :value="null"
                              :label="$translate('Noone')"
                            />
                            <option
                              v-for="optio in availablemat[optio.material]"
                              :key="optio.id"
                              :value="optio.id"
                              :label="$translateMaterial(optio)"
                            />
                          </template>
                          <!-- SELECT TIPO PLANTARI -->
                          <template v-else>
                            <option v-for="variant in optio.option" :key="variant.key" :value="variant.key">
                              {{ $translate(variant.key) }}
                            </option>
                          </template>
                        </b-select>
                        <template v-if="optio.key == 'plantar_type'">
                          <!--Qui prametro vero -->
                          <img
                            v-if="order.footmeasurements[optio.key + '_dx'] != null"
                            src="https://via.placeholder.com/100x100"
                            style="float: right"
                          />
                          <img v-else src="https://via.placeholder.com/100x100" style="float: right" />
                        </template>
                        <template v-else>
                          <img :src="getInsolePartImage(optio, 'dx')" class="insoleImage" alt="Material image" />
                        </template>
                      </b-field>
                      <b-field
                        v-if="isVariantVisible(optio, 'dx')"
                        :key="optio.key + 'var_dx'"
                        :label="$translate('variant') | capitalize"
                        :type="{ 'is-danger': errors.has(optio.key + 'var_dx') }"
                        :message="errors.first(optio.key + 'var_dx')"
                        horizontal
                      >
                        <b-select
                          v-model="order.footmeasurements[optio.key + 'var_dx']"
                          v-validate="{ required: isInsoleInfoRequired(optio.key, 'dx') }"
                          :disabled="disabledbool || order.isDunaInsoleDisabledDx"
                          :name="optio.key + 'var_dx'"
                          :placeholder="$translate('placeholder_select')"
                        >
                          <option
                            v-if="optio.key != 'base_mat'"
                            :key="null"
                            :value="null"
                            :label="$translate('Noone')"
                          />
                          <option
                            v-for="variant in availablemat[optio.material].find(
                              temp => temp.id == order.footmeasurements[optio.key + '_dx']
                            ).variants"
                            :key="variant.id"
                            :value="variant.id"
                            :label="variant.name"
                          />
                        </b-select>
                      </b-field>
                    </div>
                  </template>
                  <a v-if="!isSimplified" :class="{ linkred: see1dx }" @click="see1dx = !see1dx">
                    {{ $translate(see1dx ? 'hide_pelot_fin_dess' : 'show_pelot_fin_dess') | capitalize }}
                    <b-icon :icon="see1dx ? 'minus-circle' : 'plus-circle'" size="is-small" />
                  </a>

                  <template v-if="!isSimplified">
                    <br />
                    <br />
                    <br />
                    <a v-if="order.secondplantdx" class="linkred" @click="deleteAdditionalInsole('dx')">
                      {{ $translate('remove_plantar') | capitalize }}<b-icon icon="minus-circle" size="is-small"
                    /></a>

                    <a
                      v-else
                      @click="
                        order.secondplantdx = true
                        $forceUpdate()
                      "
                      >{{ $translate('add_plantar') | capitalize }}<b-icon icon="plus-circle" size="is-small"
                    /></a>
                  </template>
                  <br />
                  <template v-if="order.secondplantdx">
                    <template v-for="optio in $plantaremontaggio">
                      <div
                        v-if="optio.key != 'plantar_type'"
                        v-show="(optio.key != 'fin_dess' && optio.key != 'pelotte') || see2dx"
                        :key="optio.key + '_dx2'"
                        class="box"
                      >
                        <b-field
                          :key="optio.key + '_dx2'"
                          :label="$translate(optio.key) | capitalize"
                          :type="{ 'is-danger': errors.has(optio.key + '_dx2') }"
                          :message="errors.first(optio.key + '_dx2')"
                          horizontal
                        >
                          <b-select
                            v-model="order.footmeasurements[optio.key + '_dx2']"
                            v-validate="{ required: isInsoleInfoRequired(optio.key, 'dx2') }"
                            :disabled="disabledbool || order.isDunaInsoleDisabledDx"
                            :name="optio.key + '_dx2'"
                            :placeholder="$translate('placeholder_select')"
                          >
                            <template v-if="optio.material">
                              <option
                                v-if="optio.key != 'base_mat'"
                                :key="null"
                                :value="null"
                                :label="$translate('Noone')"
                              />
                              <option
                                v-for="optio in availablemat[optio.material]"
                                :key="optio.id"
                                :value="optio.id"
                                :label="$translateMaterial(optio)"
                              />
                            </template>
                          </b-select>
                          <template>
                            <img :src="getInsolePartImage(optio, 'dx2')" class="insoleImage" alt="Material image" />
                          </template>
                        </b-field>
                        <b-field
                          v-if="isVariantVisible(optio, 'dx2')"
                          :key="optio.key + 'var_dx2'"
                          :label="$translate('variant') | capitalize"
                          horizontal
                        >
                          <b-select
                            v-model="order.footmeasurements[optio.key + 'var_dx2']"
                            :disabled="disabledbool || order.isDunaInsoleDisabledDx"
                            :name="optio.key + 'var_dx2'"
                            :placeholder="$translate('placeholder_select')"
                          >
                            <option
                              v-if="optio.key != 'base_mat'"
                              :key="null"
                              :value="null"
                              :label="$translate('Noone')"
                            />
                            <option
                              v-for="variant in availablemat[optio.material].find(
                                temp => temp.id == order.footmeasurements[optio.key + '_dx2']
                              ).variants"
                              :key="variant.id"
                              :value="variant.id"
                              :label="variant.name"
                            />
                          </b-select>
                        </b-field>
                      </div>
                    </template>
                    <a :class="{ linkred: see2dx }" @click="see2dx = !see2dx">
                      {{ $translate(see2dx ? 'hide_pelot_fin_dess' : 'show_pelot_fin_dess') | capitalize }}
                      <b-icon :icon="see2dx ? 'minus-circle' : 'plus-circle'" size="is-small" />
                    </a>
                    <br />
                  </template>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>

      <div class="columns">
        <div class="column is-6">
          <strong
            >{{ $translate('label_punta_artificial') }}
            <span>
              <b-switch
                v-model="order.footmeasurements.artificial_point_sx"
                true-value="y"
                false-value="n"
                :disabled="order.pair === 'right' || disabledbool"
              />
            </span>
          </strong>
          <br />
          <br />
          <div v-if="order.footmeasurements.artificial_point_sx == 'y'">
            <b-field :label="$translate('riemp_type')" horizontal>
              <b-select v-model="order.footmeasurements.artificil_point_sx_optional">
                <option value="art_punt_1">
                  {{ $translate('art_punt_1') }}
                </option>
                <option value="art_punt_2">
                  {{ $translate('art_punt_2') }}
                </option>
                <option value="art_punt_3">
                  {{ $translate('art_punt_3') }}
                </option>
              </b-select>
              <img src="https://via.placeholder.com/50x50" style="float: right" />
            </b-field>
          </div>
        </div>
        <div class="column is-6">
          <strong
            >{{ $translate('label_punta_artificial') }}
            <span>
              <b-switch
                v-model="order.footmeasurements.artificial_point_dx"
                true-value="y"
                false-value="n"
                :disabled="order.pair === 'left' || disabledbool"
              />
            </span>
          </strong>
          <br />
          <br />
          <div v-if="order.footmeasurements.artificial_point_dx == 'y'">
            <b-field :label="$translate('riemp_type')" horizontal>
              <b-select v-model="order.footmeasurements.artificil_point_dx_optional">
                <option value="art_punt_1">
                  {{ $translate('art_punt_1') }}
                </option>
                <option value="art_punt_2">
                  {{ $translate('art_punt_2') }}
                </option>
                <option value="art_punt_3">
                  {{ $translate('art_punt_3') }}
                </option>
              </b-select>
              <img src="https://via.placeholder.com/50x50" style="float: right" />
            </b-field>
          </div>
        </div>
      </div>
    </div>

    <div v-if="order.plan_realization == 'reali_proper'">
      <div class="columns">
        <div class="column has-text-left">
          <div class="columns is-mobile">
            <div class="column is-1">
              <b-tooltip
                type="is-dark"
                position="is-right"
                :label="$translate('copy_dx_in_sx') | capitalize"
                multilined
              >
                <a
                  class="button is-primary"
                  :disabled="order.pair !== 'both' || disabledbool"
                  @click="copyplantarepropdxinsx()"
                >
                  <b-icon icon="content-copy" />
                </a>
              </b-tooltip>
            </div>
            <div class="column is-11">
              <h3 class="subtitle green">
                {{ $translate('left_shoe') | uppercase }}
              </h3>
            </div>
          </div>
        </div>
        <div class="column has-text-right">
          <div class="columns is-mobile">
            <div class="column is-11">
              <h3 class="subtitle green">
                {{ $translate('right_shoe') | uppercase }}
              </h3>
            </div>
            <div class="column is-1">
              <b-tooltip type="is-dark" position="is-left" :label="$translate('copy_sx_in_dx') | capitalize" multilined>
                <a
                  class="button is-primary"
                  :disabled="order.pair !== 'both' || disabledbool"
                  @click="copyplantarepropsxindx()"
                >
                  <b-icon icon="content-copy" />
                </a>
              </b-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-5">
          <div class="columns is-multiline">
            <div class="column is-3" />
            <div class="column is-3 bordered graybg">
              {{ $translate('measure_text') | capitalize }}
            </div>
            <div class="column is-3 bordered graybg">
              {{ $translate('heel_center') | capitalize }}
            </div>
            <div class="column is-3 bordered graybg">
              {{ $translate('plant') | capitalize }}
            </div>
            <div class="column is-3 imagecell">
              <img src="@/assets/images/definite/PredPlan180_ok.png" />
            </div>
            <div class="column is-3 bordered">
              {{ $translate('pred_form_sx') | capitalize }}
            </div>
            <div class="column is-3 bordered">
              <b-field :type="{ 'is-danger': errors.has('tacc_sx') }">
                <b-input
                  v-model="order.footmeasurements.tacc_sx"
                  name="tacc_sx"
                  type="number"
                  step="1"
                  :disabled="order.pair === 'right' || disabledbool"
                  :placeholder="$translate('placeholder_numeric_mm')"
                  @input="checkValue()"
                />
              </b-field>
            </div>
            <div class="column is-3 bordered">
              <b-field :type="{ 'is-danger': errors.has('plant_sx') }">
                <b-input
                  v-model="order.footmeasurements.plant_sx"
                  name="plant_sx"
                  type="number"
                  step="1"
                  :disabled="order.pair === 'right' || disabledbool"
                  :placeholder="$translate('placeholder_numeric_mm')"
                  @input="checkValue()"
                />
              </b-field>
            </div>
          </div>
        </div>
        <div class="column is-2" />
        <div class="column is-5">
          <div class="columns is-multiline">
            <div class="column is-3" />
            <div class="column is-3 bordered graybg">
              {{ $translate('measure_text') | capitalize }}
            </div>
            <div class="column is-3 bordered graybg">
              {{ $translate('heel_center') | capitalize }}
            </div>
            <div class="column is-3 bordered graybg">
              {{ $translate('plant') | capitalize }}
            </div>
            <div class="column is-3 imagecell">
              <img src="@/assets/images/definite/PredPlan180_ok.png" />
            </div>
            <div class="column is-3 bordered">
              {{ $translate('pred_form_dx') | capitalize }}
            </div>
            <div class="column is-3 bordered">
              <b-field :type="{ 'is-danger': errors.has('tacc_dx') }">
                <b-input
                  v-model="order.footmeasurements.tacc_dx"
                  name="tacc_dx"
                  type="number"
                  step="1"
                  :disabled="order.pair === 'left' || disabledbool"
                  :placeholder="$translate('placeholder_numeric_mm')"
                  @input="checkValue()"
                />
              </b-field>
            </div>
            <div class="column is-3 bordered">
              <b-field :type="{ 'is-danger': errors.has('plant_dx') }">
                <b-input
                  v-model="order.footmeasurements.plant_dx"
                  name="plant_dx"
                  type="number"
                  step="1"
                  :disabled="order.pair === 'left' || disabledbool"
                  :placeholder="$translate('placeholder_numeric_mm')"
                  @input="checkValue()"
                />
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr class="green" />
    <div class="columns">
      <div class="column has-text-left">
        <div class="columns is-mobile">
          <div class="column is-1">
            <b-tooltip type="is-dark" position="is-right" :label="$translate('copy_dx_in_sx') | capitalize" multilined>
              <a
                class="button is-primary"
                :disabled="order.pair !== 'both' || disabledbool"
                @click="copyallfondxinsx()"
              >
                <b-icon icon="content-copy" />
              </a>
            </b-tooltip>
          </div>
          <div class="column is-10">
            <h3 class="subtitle green">
              {{ $translate('left_shoe') | uppercase }}
            </h3>
          </div>
        </div>
      </div>
      <div class="column has-text-right">
        <div class="columns is-mobile">
          <div class="column is-11">
            <h3 class="subtitle green">
              {{ $translate('right_shoe') | uppercase }}
            </h3>
          </div>
          <div class="column is-1">
            <b-tooltip type="is-dark" position="is-left" :label="$translate('copy_sx_in_dx') | capitalize" multilined>
              <a
                class="button is-primary"
                :disabled="order.pair !== 'both' || disabledbool"
                @click="copyallfonsxindx()"
              >
                <b-icon icon="content-copy" />
              </a>
            </b-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column" style="position: relative">
        <template v-if="order.shoeType == 'low'">
          <img
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/Scarpa_BASSA_GRIGIO_SX.png"
          />
          <img
            v-show="shoeLineSx == 'high_post_tom'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/SCARPA_BASSA_ok/BH_SX.png"
          />
          <img
            v-show="shoeLineSx == 'start_lacing'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/SCARPA_BASSA_ok/CL_SX.png"
          />
          <img
            v-show="shoeLineSx == 'high_lat_tom'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/SCARPA_BASSA_ok/LH_SX.png"
          />
          <img
            v-show="shoeLineSx == 'high_med_tom'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/SCARPA_BASSA_ok/MH_SX.png"
          />
        </template>
        <template v-if="order.shoeType == 'high'">
          <img
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/Scarpa_ALTA_GRIGIO_SX.png"
          />
          <img
            v-show="shoeLineSx == 'high_post_tom'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/SCARPA_ALTA_ok/BH_SX.png"
          />
          <img
            v-show="shoeLineSx == 'start_lacing'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/SCARPA_ALTA_ok/CL_SX.png"
          />
          <img
            v-show="shoeLineSx == 'high_lat_tom'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/SCARPA_ALTA_ok/LH_SX.png"
          />
          <img
            v-show="shoeLineSx == 'high_med_tom'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/SCARPA_ALTA_ok/MH_SX.png"
          />
        </template>
        <template v-if="order.mod.tacc == 'foggiafondo0'">
          <template
            v-if="
              order.footmeasurements.ext_high_heel_sx > 0 ||
                order.footmeasurements.ext_high_pla_sx > 0 ||
                order.footmeasurements.ext_high_poi_sx > 0
            "
          >
            <img
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/Tacco_e_Intertacco_SX.png"
            />
            <img
              v-show="shoeLineSx == 'L'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO_INTERTACCO/L_SX.png"
            />
            <img
              v-show="shoeLineSx == 'high_heel_zep'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO_INTERTACCO/HT_SX.png"
            />
            <img
              v-show="shoeLineSx == 'ext_high_pla'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO_INTERTACCO/CP_SX.png"
            />
            <img
              v-show="shoeLineSx == 'ext_high_poi'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO_INTERTACCO/CPUN_SX.png"
            />
            <img
              v-show="shoeLineSx == 'ext_high_heel'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO_INTERTACCO/CT_SX.png"
            />
          </template>
          <template v-else>
            <img style="position: absolute; top: 60; left: 0; right: 0" src="@/assets/images/fondi/Tacco_SX.png" />
            <img
              v-show="shoeLineSx == 'L'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO/L_SX.png"
            />
            <img
              v-show="shoeLineSx == 'high_heel_zep'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO/HT_SX.png"
            />
            <img
              v-show="shoeLineSx == 'ext_high_pla'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO_INTERTACCO/CP_SX.png"
            />
            <img
              v-show="shoeLineSx == 'ext_high_poi'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO_INTERTACCO/CPUN_SX.png"
            />
            <img
              v-show="shoeLineSx == 'ext_high_heel'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO_INTERTACCO/CT_SX.png"
            />
          </template>
        </template>
        <template v-if="order.mod.tacc == 'foggiafondo1'">
          <template
            v-if="
              order.footmeasurements.ext_high_heel_sx > 0 ||
                order.footmeasurements.ext_high_pla_sx > 0 ||
                order.footmeasurements.ext_high_poi_sx > 0
            "
          >
            <img
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/Zeppa_e_Intersuola_SX.png"
            />
            <img
              v-show="shoeLineSx == 'L'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_INTERSUOLA/L_SX.png"
            />
            <img
              v-show="shoeLineSx == 'high_heel_zep'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_INTERSUOLA/HT_SX.png"
            />
            <img
              v-show="shoeLineSx == 'ext_high_pla'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_INTERSUOLA/CP_SX.png"
            />
            <img
              v-show="shoeLineSx == 'ext_high_poi'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_INTERSUOLA/CPUN_SX.png"
            />
            <img
              v-show="shoeLineSx == 'ext_high_heel'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_INTERSUOLA/CT_SX.png"
            />
          </template>
          <template v-else>
            <img style="position: absolute; top: 60; left: 0; right: 0" src="@/assets/images/fondi/Zeppa_SX.png" />
            <img
              v-show="shoeLineSx == 'L'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA/L_SX.png"
            />
            <img
              v-show="shoeLineSx == 'high_heel_zep'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA/HT_SX.png"
            />
            <img
              v-show="shoeLineSx == 'ext_high_pla'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_INTERSUOLA/CP_SX.png"
            />
            <img
              v-show="shoeLineSx == 'ext_high_poi'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_INTERSUOLA/CPUN_SX.png"
            />
            <img
              v-show="shoeLineSx == 'ext_high_heel'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_INTERSUOLA/CT_SX.png"
            />
          </template>
        </template>
        <template v-if="order.mod.tacc == 'foggiafondo2'">
          <img
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/Suola_Deambulante_SX.png"
          />
          <img
            v-show="shoeLineSx == 'L'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_DEAMBULANTE/L_SX.png"
          />
          <img
            v-show="shoeLineSx == 'high_heel_zep'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_DEAMBULANTE/HT_SX.png"
          />
          <img
            v-show="shoeLineSx == 'ext_high_pla'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_DEAMBULANTE/CP_SX.png"
          />
          <img
            v-show="shoeLineSx == 'ext_high_poi'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_DEAMBULANTE/CPUN_SX.png"
          />
          <img
            v-show="shoeLineSx == 'ext_high_heel'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_DEAMBULANTE/CT_SX.png"
          />
        </template>
      </div>
      <div class="column is-6">
        <table class="bordered-table static">
          <tr>
            <td>
              <b-field :type="{ 'is-danger': errors.has('measure_sx') }">
                <b-input
                  v-model="order.footmeasurements['measure_sx']"
                  v-validate="{
                    required:
                      order.pair !== 'right' &&
                      order.footmeasurements.c_pair != 'dx_c_pa' &&
                      ['measurements', 'digitalMeasurements', 'mold'].includes(order.orderTypeMain),
                    from1to100: order.pair !== 'right',
                  }"
                  name="measure_sx"
                  :disabled="order.pair === 'right' || disabledbool"
                  :placeholder="$translate('size')"
                  type="number"
                  step="0.5"
                  min
                  @focus="shoeLineSx = 'L'"
                  @blur="shoeLineSx = ''"
                  @input="
                    checkValue()
                    shoeLineSx = 'L'
                  "
                />
              </b-field>
            </td>
            <td>
              <h3 class="subtitle green has-text-centered has-text-weight-bold">
                {{ $translate('measure') | uppercase }}
              </h3>
            </td>

            <td>
              <b-field :type="{ 'is-danger': errors.has('measure_dx') }">
                <b-input
                  v-model="order.footmeasurements['measure_dx']"
                  v-validate="{
                    required:
                      order.pair !== 'left' &&
                      order.footmeasurements.c_pair != 'sx_c_pa' &&
                      ['measurements', 'digitalMeasurements', 'mold'].includes(order.orderTypeMain),
                    from1to100: order.pair !== 'left',
                  }"
                  name="measure_dx"
                  :disabled="order.pair === 'left' || disabledbool"
                  :placeholder="$translate('size')"
                  type="number"
                  step="0.5"
                  @focus="shoeLineDx = 'L'"
                  @blur="shoeLineDx = ''"
                  @input="checkValue()"
                />
              </b-field>
            </td>
          </tr>
          <tr>
            <td />
            <td><hr class="green" /></td>
            <td />
          </tr>
          <tr>
            <td />
            <td>
              <h3 class="subtitle green has-text-centered has-text-weight-bold">
                {{ $translate('tomaiatitle') | uppercase }}
              </h3>
            </td>
            <td />
          </tr>
          <tr v-for="variant in $allacciaturames" :key="variant.key">
            <template v-for="x in ['_sx', 'center', '_dx']">
              <td :key="x">
                <strong v-if="x == 'center'">{{ $translate(variant.key) | capitalize }}</strong>
                <b-field
                  v-else
                  :key="x"
                  :type="{ 'is-danger': errors.has(variant.key + x) }"
                  :message="errors.first(variant.key + x)"
                >
                  <b-input
                    v-model="order.footmeasurements[variant.key + x]"
                    v-validate="{
                      from5to130:
                        variant.key === 'high_post_tom' &&
                        order.shoeType === 'low' &&
                        ((x === '_sx' && order.pair !== 'right') || (x === '_dx' && order.pair !== 'left')),
                      from70to500:
                        variant.key === 'high_post_tom' &&
                        order.shoeType === 'high' &&
                        ((x === '_sx' && order.pair !== 'right') || (x === '_dx' && order.pair !== 'left')),
                      required:
                        variant.key === 'high_post_tom' &&
                        order.shoeType === 'high' &&
                        order.deliverySelected === 'onlytom' &&
                        ((x === '_sx' && order.pair !== 'right' && order.footmeasurements.c_pair != 'dx_c_pa') ||
                          (x === '_dx' && order.pair !== 'left' && order.footmeasurements.c_pair != 'sx_c_pa')),
                    }"
                    :disabled="
                      (x === '_sx' && order.pair === 'right') || (x === '_dx' && order.pair === 'left') || disabledbool
                    "
                    :name="variant.key + x"
                    :placeholder="$translate('placeholder_numeric_mm')"
                    type="number"
                    step="1"
                    @focus="selectShoeLine(variant.key, x)"
                    @blur="
                      shoeLineSx = ''
                      shoeLineDx = ''
                    "
                    @input="checkValue()"
                  />
                </b-field>
              </td>
            </template>
          </tr>
          <tr>
            <td />
            <td><hr class="green" /></td>
            <td />
          </tr>
          <tr>
            <td />
            <td>
              <h3 class="subtitle green has-text-centered has-text-weight-bold">
                {{ $translate('fondo') | uppercase }}
              </h3>
            </td>
            <td />
          </tr>

          <tr v-for="variant in $fondo" :key="variant.key">
            <template v-for="x in ['_sx', 'center', '_dx']">
              <td :key="x">
                <strong v-if="x == 'center'" style="white-space: nowrap"
                  >{{ $translate(variant.key) | capitalize }}
                  <b-tooltip
                    v-if="variant.key == 'spe_heel' || variant.key == 'spe_poi'"
                    type="is-dark"
                    :label="$translate('help_pair_tilted') | capitalize"
                    multilined
                  >
                    <b-icon size="is-small" icon="help-circle-outline" />
                  </b-tooltip>
                </strong>
                <b-field v-else :key="x" :type="{ 'is-danger': errors.has(variant.key + x) }">
                  <b-input
                    v-model="order.footmeasurements[variant.key + x]"
                    v-validate="{
                      required:
                        //(x === '_sx' && order.pair !== 'right') ||
                        //(x === '_dx' && order.pair !== 'left') ||
                        (order.footmeasurements.c_pair != 'dx_c_pa' &&
                          variant.key == 'high_heel_zep' &&
                          order.pair !== 'right' &&
                          x == '_sx' &&
                          order.deliverySelected != 'onlyforme' &&
                          order.deliverySelected != 'onlytom' &&
                          order.deliverySelected != 'trymont' &&
                          (order.mod.tacc != 'foggiafondo2' ||
                            (!order.footmeasurements.ext_high_heel_sx && order.mod.tacc == 'foggiafondo2'))) ||
                        (order.footmeasurements.c_pair != 'sx_c_pa' &&
                          variant.key == 'high_heel_zep' &&
                          order.pair !== 'left' &&
                          x == '_dx' &&
                          order.deliverySelected != 'onlyforme' &&
                          order.deliverySelected != 'onlytom' &&
                          order.deliverySelected != 'trymont' &&
                          (order.mod.tacc != 'foggiafondo2' ||
                            (!order.footmeasurements.ext_high_heel_dx && order.mod.tacc == 'foggiafondo2'))),
                    }"
                    :disabled="
                      (x === '_dx' && order.pair === 'left') ||
                        (x === '_sx' && order.pair === 'right') ||
                        disabledbool ||
                        (order.deliverySelected == 'onlytom' && variant.key != 'high_heel_zep')
                    "
                    :name="variant.key + x"
                    :placeholder="$translate('placeholder_numeric_mm')"
                    type="number"
                    step="1"
                    @focus="selectShoeLine(variant.key, x)"
                    @blur="
                      shoeLineSx = ''
                      shoeLineDx = ''
                    "
                    @input="checkValue()"
                  />
                </b-field>
              </td>
            </template>
          </tr>
          <tr>
            <td />
            <td><hr class="green" /></td>
            <td />
          </tr>
          <tr>
            <td>
              <b-field :type="{ 'is-danger': errors.has('crimp_heel_sx') }">
                <b-input
                  v-model="order.footmeasurements['crimp_heel_sx']"
                  :disabled="true"
                  :name="'crimp_heel_sx'"
                  :placeholder="$translate('placeholder_numeric_mm')"
                  type="number"
                  step="1"
                  @input="checkValue()"
                />
              </b-field>
            </td>
            <td style="text-align: center; vertical-align: middle; width: 33%">
              <h3 class="subtitle green has-text-centered has-text-weight-bold">
                {{ $translate('crimp_heel') | uppercase }}
              </h3>
            </td>
            <td>
              <b-field :type="{ 'is-danger': errors.has('crimp_heel_dx') }">
                <b-input
                  v-model="order.footmeasurements['crimp_heel_dx']"
                  :disabled="true"
                  :name="'crimp_heel_sx'"
                  :placeholder="$translate('placeholder_numeric_mm')"
                  type="number"
                  step="1"
                  @input="checkValue()"
                />
              </b-field>
            </td>
          </tr>
        </table>
      </div>
      <div class="column" style="position: relative">
        <template v-if="order.shoeType == 'low'">
          <img
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/Scarpa_BASSA_GRIGIO_DX.png"
          />
          <img
            v-show="shoeLineDx == 'high_post_tom'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/SCARPA_BASSA_ok/BH_DX.png"
          />
          <img
            v-show="shoeLineDx == 'start_lacing'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/SCARPA_BASSA_ok/CL_DX.png"
          />
          <img
            v-show="shoeLineDx == 'high_lat_tom'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/SCARPA_BASSA_ok/LH_DX.png"
          />
          <img
            v-show="shoeLineDx == 'high_med_tom'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/SCARPA_BASSA_ok/MH_DX.png"
          />
        </template>
        <template v-if="order.shoeType == 'high'">
          <img
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/Scarpa_ALTA_GRIGIO_DX.png"
          />
          <img
            v-show="shoeLineDx == 'high_post_tom'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/SCARPA_ALTA_ok/BH_DX.png"
          />
          <img
            v-show="shoeLineDx == 'start_lacing'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/SCARPA_ALTA_ok/CL_DX.png"
          />
          <img
            v-show="shoeLineDx == 'high_lat_tom'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/SCARPA_ALTA_ok/LH_DX.png"
          />
          <img
            v-show="shoeLineDx == 'high_med_tom'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/SCARPA_ALTA_ok/MH_DX.png"
          />
        </template>
        <template v-if="order.mod.tacc == 'foggiafondo0'">
          <template
            v-if="
              order.footmeasurements.ext_high_heel_dx > 0 ||
                order.footmeasurements.ext_high_pla_dx > 0 ||
                order.footmeasurements.ext_high_poi_dx > 0
            "
          >
            <img
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/Tacco_e_Intertacco_DX.png"
            />
            <img
              v-show="shoeLineDx == 'L'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO_INTERTACCO/L_DX.png"
            />
            <img
              v-show="shoeLineDx == 'high_heel_zep'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO_INTERTACCO/HT_DX.png"
            />
            <img
              v-show="shoeLineDx == 'ext_high_pla'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO_INTERTACCO/CP_DX.png"
            />
            <img
              v-show="shoeLineDx == 'ext_high_poi'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO_INTERTACCO/CPUN_DX.png"
            />
            <img
              v-show="shoeLineDx == 'ext_high_heel'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO_INTERTACCO/CT_DX.png"
            />
          </template>
          <template v-else>
            <img style="position: absolute; top: 60; left: 0; right: 0" src="@/assets/images/fondi/Tacco_DX.png" />
            <img
              v-show="shoeLineDx == 'L'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO/L_DX.png"
            />
            <img
              v-show="shoeLineDx == 'high_heel_zep'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO/HT_DX.png"
            />
            <img
              v-show="shoeLineDx == 'ext_high_pla'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO_INTERTACCO/CP_DX.png"
            />
            <img
              v-show="shoeLineDx == 'ext_high_poi'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO_INTERTACCO/CPUN_DX.png"
            />
            <img
              v-show="shoeLineDx == 'ext_high_heel'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/TACCO_INTERTACCO/CT_DX.png"
            />
          </template>
        </template>
        <template v-if="order.mod.tacc == 'foggiafondo1'">
          <template
            v-if="
              order.footmeasurements.ext_high_heel_dx > 0 ||
                order.footmeasurements.ext_high_pla_dx > 0 ||
                order.footmeasurements.ext_high_poi_dx > 0
            "
          >
            <img
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/Zeppa_e_Intersuola_DX.png"
            />
            <img
              v-show="shoeLineDx == 'L'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_INTERSUOLA/L_DX.png"
            />
            <img
              v-show="shoeLineDx == 'high_heel_zep'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_INTERSUOLA/HT_DX.png"
            />
            <img
              v-show="shoeLineDx == 'ext_high_pla'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_INTERSUOLA/CP_DX.png"
            />
            <img
              v-show="shoeLineDx == 'ext_high_poi'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_INTERSUOLA/CPUN_DX.png"
            />
            <img
              v-show="shoeLineDx == 'ext_high_heel'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_INTERSUOLA/CT_DX.png"
            />
          </template>
          <template v-else>
            <img style="position: absolute; top: 60; left: 0; right: 0" src="@/assets/images/fondi/Zeppa_DX.png" />
            <img
              v-show="shoeLineDx == 'L'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA/L_DX.png"
            />
            <img
              v-show="shoeLineDx == 'high_heel_zep'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA/HT_DX.png"
            />
            <img
              v-show="shoeLineDx == 'ext_high_pla'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_INTERSUOLA/CP_DX.png"
            />
            <img
              v-show="shoeLineDx == 'ext_high_poi'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_INTERSUOLA/CPUN_DX.png"
            />
            <img
              v-show="shoeLineDx == 'ext_high_heel'"
              style="position: absolute; top: 60; left: 0; right: 0"
              src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_INTERSUOLA/CT_DX.png"
            />
          </template>
        </template>
        <template v-if="order.mod.tacc == 'foggiafondo2'">
          <img
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/Suola_Deambulante_DX.png"
          />
          <img
            v-show="shoeLineDx == 'L'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_DEAMBULANTE/L_DX.png"
          />
          <img
            v-show="shoeLineDx == 'high_heel_zep'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_DEAMBULANTE/HT_DX.png"
          />
          <img
            v-show="shoeLineDx == 'ext_high_pla'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_DEAMBULANTE/CP_DX.png"
          />
          <img
            v-show="shoeLineDx == 'ext_high_poi'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_DEAMBULANTE/CPUN_DX.png"
          />
          <img
            v-show="shoeLineDx == 'ext_high_heel'"
            style="position: absolute; top: 60; left: 0; right: 0"
            src="@/assets/images/fondi/LINEE_MISURA/ZEPPA_DEAMBULANTE/CT_DX.png"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../helpers/mixins/variables/highlowmeauserements'
import '../../../helpers/mixins/variables/fondo'
import '../../../helpers/mixins/variables/plantare'
import '../../../helpers/mixins/variables/plantaremontaggio'
import '../../../helpers/mixins/variables/allacciaturames'
import '../../../helpers/mixins/variables/formames'
import '../../../helpers/mixins/variables/stylepoint'

export default {
  name: 'Measurements',
  props: [
    'order',
    'availablemoi',
    'availablesup_plan',
    'availableriv_plan',
    'availablepel',
    'arraytodelete',
    'disabledbool',
    'missingattachment',
    'isSimplified',
  ],
  //props: {
  //  order: {
  //    type: Object,
  //    default: () => {
  //      return {}
  //    }
  //  },
  //  availablemoi: {
  //    type: Array,
  //    default: () => {
  //      return []
  //    }
  //  },
  //  availablesupPlan: {
  //    type: Array,
  //    default: () => {
  //      return []
  //    }
  //  },
  //  availablerivPlan: {
  //    type: Array,
  //    default: () => {
  //      return []
  //    }
  //  },
  //  availablepel: {
  //    type: Array,
  //    default: () => {
  //      return []
  //    }
  //  },
  //  arraytodelete: {
  //    type: Object,
  //    default: () => {
  //      return {}
  //    }
  //  },
  //  disabledbool: {
  //    type: Boolean,
  //    default: false
  //  },
  //  missingattachment: {
  //    type: Boolean,
  //    default: false
  //  }
  //},
  inject: ['$validator'],
  data() {
    return {
      reali_duna_bool_sx: true,
      reali_duna_bool_dx: true,
      isComponentModalAttachSx: false,
      isComponentModalAttachDx: false,
      isComponentModalScanNoDUSx: false,
      isComponentModalScanNoDUDx: false,
      isComponentModalGrapSx: false,
      isComponentModalGrapDx: false,
      isComponentModalScanSx: false,
      isComponentModalScanSxComparison: false,
      isComponentModalScanDx: false,
      isComponentModalScanDxComparison: false,
      tempfootmeasurementssx: {},
      tempfootmeasurementsdx: {},
      images: {},
      publicPath: process.env.BASE_URL,
      scan_fms_sx: null,
      scan_fms_scan_sx: null,
      scan_fms_dx: null,
      scan_fms_scan_dx: null,
      availablemat: {},
      see1dx: false,
      see1sx: false,
      see2dx: false,
      see2sx: false,
      shoeLineSx: '',
      shoeLineDx: '',
      isHighHeelSxSet: false,
      isHighHeelDxSet: false,
      isHighHeelZepSxSet: false,
      isHighHeelZepDxSet: false,
      footMeasurementsVisible: !this.isSimplified,
    }
  },
  watch: {
    availablemoi: function() {
      this.availablemat['Moi'] = this.availablemoi
    },
    availablesup_plan: function() {
      this.availablemat['Sup_plan'] = this.availablesup_plan
    },
    availableriv_plan: function() {
      this.availablemat['Riv_plan'] = this.availableriv_plan
    },
    availablepel: function() {
      this.availablemat['Pelo'] = this.availablepel
    },
    order: {
      deep: true,
      handler() {
        this.order.isDunaInsoleDisabledDx = !!this.order.isDunaInsoleDisabledDx
        this.order.isDunaInsoleDisabledSx = !!this.order.isDunaInsoleDisabledSx
        //this.checkValue();
      },
    },
  },
  created() {
    this.availablemat['Moi'] = this.availablemoi
    this.availablemat['Sup_plan'] = this.availablesup_plan
    this.availablemat['Riv_plan'] = this.availableriv_plan
    this.availablemat['Pelo'] = this.availablepel
    this.$validator.extend('nooneSelected', value => {
      if (value == 'Noone') return false
      return true
    })
    this.$validator.extend('from1to100', value => {
      if (value && value <= 100 && value >= 1) {
        return true
      }
      return false
    })
    this.$validator.extend('from15to80', value => {
      if (value <= 80 && value >= 15) {
        return true
      }
      return false
    })
    this.$validator.extend('from5to130', value => {
      if (value <= 130 && value >= 5) {
        return true
      }
      return false
    })
    this.$validator.extend('from70to500', value => {
      if (value <= 500 && value >= 70) {
        return true
      }
      return false
    })
    this.$validator.extend('threeneeding', value => {
      if (value.length == 3 || value.length == 0) {
        return true
      }
      return false
    })
    this.checkValue()

    this.isHighHeelSxSet = !!this.order.footmeasurements.high_heel_sx
    this.isHighHeelDxSet = !!this.order.footmeasurements.high_heel_dx
    this.isHighHeelZepSxSet = !!this.order.footmeasurements.high_heel_zep_sx
    this.isHighHeelZepDxSet = !!this.order.footmeasurements.high_heel_zep_dx
  },
  methods: {
    isVariantVisible(option, side) {
      //console.log(option)
      //console.log(this.availablemat['Riv_plan'][0].variants)
      if (option.material && this.order.footmeasurements[`${option.key}_${side}`]) {
        let selectedMaterial = this.availablemat[option.material].find(
          material => material.id == this.order.footmeasurements[`${option.key}_${side}`]
        )
        if (selectedMaterial) return true
      }
      return false
    },
    getInsolePartImage(option, side) {
      //console.log(option)
      //console.log(side)
      let selectionId = this.order.footmeasurements[`${option.key}_${side}`]
      let variantId = this.order.footmeasurements[`${option.key}var_${side}`]
      if (selectionId && variantId) {
        //console.log(this.availablemat[option.material])
        let selection = this.availablemat[option.material].find(element => element.id == selectionId)
        if (selection) {
          let variant = selection.variants.find(element => element.id == variantId)
          if (variant) return variant.image
        }
      }
      return 'https://via.placeholder.com/100x100'
    },
    //isInsoleInfoRequired(key) {
    //  if (!this.order.isDunaInsoleDisabledSx && (key == "base_mat" || key == "plantar_type")) {
    //    return true
    //  }
    //  if (!this.order.isDunaInsoleDisabledDx && (key == "base_mat" || key == "plantar_type"))
    //  return false
    //},
    isInsoleInfoRequired(key, side) {
      if (!this.order.isDunaInsoleDisabledSx && (key == 'base_mat' || key == 'plantar_type') && side == 'sx') {
        return true
      }
      if (!this.order.isDunaInsoleDisabledDx && (key == 'base_mat' || key == 'plantar_type') && side == 'dx') {
        return true
      }
      if (
        !this.order.isDunaInsoleDisabledSx &&
        (key == 'base_mat' || key == 'plantar_type') &&
        side == 'sx2' &&
        this.order.secondplantsx
      ) {
        return true
      }
      if (
        !this.order.isDunaInsoleDisabledDx &&
        (key == 'base_mat' || key == 'plantar_type') &&
        side == 'dx2' &&
        this.order.secondplantdx
      ) {
        return true
      }
      return false
    },
    deleteAdditionalInsole(side) {
      if (side == 'sx') {
        this.order.secondplantsx = false
        this.order.footmeasurements.base_mat_sx2 = null
        this.order.footmeasurements.base_matvar_sx2 = null
        this.order.footmeasurements.surface_mat_sx2 = null
        this.order.footmeasurements.surface_matvar_sx2 = null
        this.order.footmeasurements.fin_dess_sx2 = null
        this.order.footmeasurements.fin_dessvar_sx2 = null
        this.order.footmeasurements.pelotte_sx2 = null
        this.order.footmeasurements.pelottevar_sx2 = null
      } else {
        this.order.secondplantdx = false
        this.order.footmeasurements.base_mat_dx2 = null
        this.order.footmeasurements.base_matvar_dx2 = null
        this.order.footmeasurements.surface_mat_dx2 = null
        this.order.footmeasurements.surface_matvar_dx2 = null
        this.order.footmeasurements.fin_dess_dx2 = null
        this.order.footmeasurements.fin_dessvar_dx2 = null
        this.order.footmeasurements.pelotte_dx2 = null
        this.order.footmeasurements.pelottevar_dx2 = null
      }
      this.$forceUpdate()
    },
    copyInsoleDetailsSxinDx() {
      this.order.footmeasurements = {
        ...this.order.footmeasurements,
        plantar_type_dx: this.order.footmeasurements.plantar_type_sx || null,
        base_mat_dx: this.order.footmeasurements.base_mat_sx || null,
        base_matvar_dx: this.order.footmeasurements.base_matvar_sx || null,
        surface_mat_dx: this.order.footmeasurements.surface_mat_sx || null,
        surface_matvar_dx: this.order.footmeasurements.surface_matvar_sx || null,
        fin_dess_dx: this.order.footmeasurements.fin_dess_sx || null,
        fin_dessvar_dx: this.order.footmeasurements.fin_dessvar_sx || null,
        fin_pelotte_dx: this.order.footmeasurements.fin_pelotte_sx || null,
        base_mat_dx2: this.order.footmeasurements.base_mat_sx2 || null,
        base_matvar_dx2: this.order.footmeasurements.base_matvar_sx2 || null,
        surface_mat_dx2: this.order.footmeasurements.surface_mat_sx2 || null,
        surface_matvar_dx2: this.order.footmeasurements.surface_matvar_sx2 || null,
        fin_dess_dx2: this.order.footmeasurements.fin_dess_sx2 || null,
        fin_dessvar_dx2: this.order.footmeasurements.fin_dessvar_sx2 || null,
        pelotte_dx2: this.order.footmeasurements.pelotte_sx2 || null,
        pelottevar_dx2: this.order.footmeasurements.pelottevar_sx2 || null,
        pelotte_dx: this.order.footmeasurements.pelotte_sx || null,
        pelottevar_dx: this.order.footmeasurements.pelottevar_sx || null,
      }
    },
    copyInsoleDetailsDxinSx() {
      this.order.footmeasurements = {
        ...this.order.footmeasurements,
        plantar_type_sx: this.order.footmeasurements.plantar_type_dx || null,
        base_mat_sx: this.order.footmeasurements.base_mat_dx || null,
        base_matvar_sx: this.order.footmeasurements.base_matvar_dx || null,
        surface_mat_sx: this.order.footmeasurements.surface_mat_dx || null,
        surface_matvar_sx: this.order.footmeasurements.surface_matvar_dx || null,
        fin_dess_sx: this.order.footmeasurements.fin_dess_dx || null,
        fin_dessvar_sx: this.order.footmeasurements.fin_dessvar_dx || null,
        fin_pelotte_sx: this.order.footmeasurements.fin_pelotte_dx || null,
        base_mat_sx2: this.order.footmeasurements.base_mat_dx2 || null,
        base_matvar_sx2: this.order.footmeasurements.base_matvar_dx2 || null,
        surface_mat_sx2: this.order.footmeasurements.surface_mat_dx2 || null,
        surface_matvar_sx2: this.order.footmeasurements.surface_matvar_dx2 || null,
        fin_dess_sx2: this.order.footmeasurements.fin_dess_dx2 || null,
        fin_dessvar_sx2: this.order.footmeasurements.fin_dessvar_dx2 || null,
        pelotte_sx2: this.order.footmeasurements.pelotte_dx2 || null,
        pelottevar_sx2: this.order.footmeasurements.pelottevar_dx2 || null,
        pelotte_sx: this.order.footmeasurements.pelotte_dx || null,
        pelottevar_sx: this.order.footmeasurements.pelottevar_dx || null,
      }
    },
    selectShoeLine(variant, side) {
      if (side == '_sx') {
        this.shoeLineSx = variant
      } else {
        this.shoeLineDx = variant
      }
    },
    resetDunaInsoleValues(side) {
      //this.order.isDunaInsoleDisabledDx=!this.reali_duna_bool_dx
      //this.order.isDunaInsoleDisabledSx=!this.reali_duna_bool_sx
      //console.log(this.order.isDunaInsoleDisabledDx)
      this.order.secondplantdx = false
      this.order.secondplantsx = false
      this.$plantare.forEach(measure => {
        this.order.footmeasurements[measure.key + side] = null
      })
      this.$forceUpdate
    },
    planRealizationChanged() {
      if (this.order.plan_realization != 'reali_duna') {
        this.order.secondplantdx = false
        this.order.secondplantsx = false
        this.order.footmeasurements['thick_cen_heel_sx'] = null
        this.order.footmeasurements['thick_pla_sx'] = null
        this.order.footmeasurements['thick_poi_sx'] = null
        this.order.footmeasurements['pla_til_heel_sx'] = null
        this.order.footmeasurements['pla_til_poi_sx'] = null
        this.order.footmeasurements['height_col_med_sx'] = null
        this.order.footmeasurements['height_col_lat_sx'] = null
        this.order.footmeasurements['thick_cen_heel_dx'] = null
        this.order.footmeasurements['thick_pla_dx'] = null
        this.order.footmeasurements['thick_poi_dx'] = null
        this.order.footmeasurements['pla_til_heel_dx'] = null
        this.order.footmeasurements['pla_til_poi_dx'] = null
        this.order.footmeasurements['height_col_med_dx'] = null
        this.order.footmeasurements['height_col_lat_dx'] = null
        this.order.footmeasurements['artificial_point_sx'] = 'n'
        this.order.footmeasurements['artificil_point_sx_optional'] = null
        this.order.footmeasurements['artificial_point_dx'] = 'n'
        this.order.footmeasurements['artificil_point_dx_optional'] = null
        this.order.footmeasurements['plantar_type_sx'] = 'Noone'
        this.order.footmeasurements['base_mat_sx'] = null
        this.order.footmeasurements['base_matvar_sx'] = null
        this.order.footmeasurements['surface_mat_sx'] = null
        this.order.footmeasurements['fin_dess_sx'] = null
        this.order.footmeasurements['pelotte_sx'] = null
        this.order.footmeasurements['base_mat_sx2'] = null
        this.order.footmeasurements['base_matvar_sx2'] = null
        this.order.footmeasurements['surface_mat_sx2'] = null
        this.order.footmeasurements['fin_dess_sx2'] = null
        this.order.footmeasurements['pelotte_sx2'] = null
        this.order.footmeasurements['plantar_type_dx'] = 'Noone'
        this.order.footmeasurements['base_mat_dx'] = null
        this.order.footmeasurements['base_matvar_dx'] = null
        this.order.footmeasurements['surface_mat_dx'] = null
        this.order.footmeasurements['fin_dess_dx'] = null
        this.order.footmeasurements['pelotte_dx'] = null
        this.order.footmeasurements['base_mat_dx2'] = null
        this.order.footmeasurements['base_matvar_dx2'] = null
        this.order.footmeasurements['surface_mat_dx2'] = null
        this.order.footmeasurements['fin_dess_dx2'] = null
        this.order.footmeasurements['pelotte_dx2'] = null
      }
      if (this.order.plan_realization != 'reali_proper') {
        this.order.footmeasurements['plant_sx'] = null
        this.order.footmeasurements['tacc_sx'] = null
        this.order.footmeasurements['plant_dx'] = null
        this.order.footmeasurements['tacc_dx'] = null
      }
      if (this.order.plan_realization == 'reali_duna') {
        if (this.order.footmeasurements['plantar_type_sx'] === 'Noone') {
          this.order.footmeasurements['plantar_type_sx'] = null
        }
        if (this.order.footmeasurements['plantar_type_dx'] === 'Noone') {
          this.order.footmeasurements['plantar_type_dx'] = null
        }
      }
      this.checkValue()
    },
    // changeWithoutJunction() {
    //   if (this.order.footmeasurements["without_junction"]) {
    //     this.order.footmeasurements["last_in"] = this.order.footmeasurements[
    //       "without_junction"
    //     ];
    //     this.$forceUpdate();
    //   }
    // },
    onMeasurementsBlur() {
      this.setShoeMeasure()
      this.isHighHeelSxSet = !!this.order.footmeasurements.high_heel_sx
      this.isHighHeelDxSet = !!this.order.footmeasurements.high_heel_dx
      this.isHighHeelZepSxSet = !!this.order.footmeasurements.high_heel_zep_sx
      this.isHighHeelZepDxSet = !!this.order.footmeasurements.high_heel_zep_dx
      if (this.isHighHeelSxSet && !this.isHighHeelZepSxSet) {
        this.order.footmeasurements.high_heel_zep_sx = this.order.footmeasurements.high_heel_sx
      }
      if (this.isHighHeelDxSet && !this.isHighHeelZepDxSet) {
        this.order.footmeasurements.high_heel_zep_dx = this.order.footmeasurements.high_heel_dx
      }
      this.checkValue()
    },
    checkValue() {
      // if (!this.isHighHeelSxSet && !this.order.footmeasurements.high_heel_zep_sx) {
      //   this.order.footmeasurements.high_heel_zep_sx = this.order.footmeasurements.high_heel_sx
      // }
      // if (!this.isHighHeelDxSet && !this.order.footmeasurements.high_heel_zep_dx) {
      //   this.order.footmeasurements.high_heel_zep_dx = this.order.footmeasurements.high_heel_dx
      // }
      // if (
      // this.order.footmeasurements.controllhigh_heel_sx !=
      // this.order.footmeasurements.high_heel_sx
      // ) {
      // this.order.footmeasurements.high_heel_zep_sx =
      // this.order.footmeasurements.high_heel_sx;
      // this.order.footmeasurements.controllhigh_heel_sx =
      // this.order.footmeasurements.high_heel_sx;
      // }
      // if (
      // this.order.footmeasurements.controllhigh_heel_dx !=
      // this.order.footmeasurements.high_heel_dx
      // ) {
      // this.order.footmeasurements.high_heel_zep_dx =
      // this.order.footmeasurements.high_heel_dx;
      // this.order.footmeasurements.controllhigh_heel_dx =
      // this.order.footmeasurements.high_heel_dx;
      // }

      // if (
      //   this.order.footmeasurements.controllfoot_long_sx !=
      //   this.order.footmeasurements.foot_long_sx
      // ) {
      //   this.order.footmeasurements.measure_sx =
      //     Math.round(
      //       (((this.order.footmeasurements.foot_long_sx / 10) * 3) / 2 + 1) /
      //         0.5
      //     ) * 0.5;

      //   this.order.footmeasurements.controllfoot_long_sx =
      //     this.order.footmeasurements.foot_long_sx;
      // }
      // if (
      //   this.order.footmeasurements.controllfoot_long_dx !=
      //   this.order.footmeasurements.foot_long_dx
      // ) {
      //   this.order.footmeasurements.measure_dx =
      //     Math.round(
      //       (((this.order.footmeasurements.foot_long_dx / 10) * 3) / 2 + 1) /
      //         0.5
      //     ) * 0.5;
      //   this.order.footmeasurements.controllfoot_long_dx =
      //     this.order.footmeasurements.foot_long_dx;
      // }

      // if (
      //   this.order.footmeasurements.controllf_long_formplan_sx !=
      //   this.order.footmeasurements.f_long_formplan_sx
      // ) {
      //   this.order.footmeasurements.measure_sx =
      //     Math.round(
      //       ((this.order.footmeasurements.f_long_formplan_sx / 10) * 3) /
      //         2 /
      //         0.5
      //     ) * 0.5;
      //   this.order.footmeasurements.controllf_long_formplan_sx =
      //     this.order.footmeasurements.f_long_formplan_sx;
      // }

      // if (
      //   this.order.footmeasurements.controllf_long_formplan_dx !=
      //   this.order.footmeasurements.f_long_formplan_dx
      // ) {
      //   this.order.footmeasurements.measure_dx =
      //     Math.round(
      //       ((this.order.footmeasurements.f_long_formplan_dx / 10) * 3) /
      //         2 /
      //         0.5
      //     ) * 0.5;
      //   this.order.footmeasurements.controllf_long_formplan_dx =
      //     this.order.footmeasurements.f_long_formplan_dx;
      // }

      if (this.order.attachment.scan_fms_sx != this.scan_fms_sx) {
        this.scan_fms_sx = this.order.attachment.scan_fms_sx
        if (this.scan_fms_sx != null && this.scan_fms_sx.name) {
          const reader = new FileReader()
          reader.onload = event => {
            var contents = event.target.result
            this.readFile(contents, 'sx')
          }
          reader.readAsText(this.scan_fms_sx)
        } else {
          fetch(this.scan_fms_sx)
            .then(res => res.blob())
            .then(blob => {
              const reader = new FileReader()
              reader.onload = event => {
                var contents = event.target.result
                this.readFile(contents, 'sx')
              }
              reader.readAsText(blob)
            })
        }
      }

      if (this.order.attachment.scan_fms_dx != this.scan_fms_dx) {
        this.scan_fms_dx = this.order.attachment.scan_fms_dx
        if (this.scan_fms_dx != null && this.scan_fms_dx.name) {
          const reader = new FileReader()
          reader.onload = event => {
            var contents = event.target.result
            this.readFile(contents, 'dx')
          }
          reader.readAsText(this.scan_fms_dx)
        } else {
          fetch(this.scan_fms_dx)
            .then(res => res.blob())
            .then(blob => {
              const reader = new FileReader()
              reader.onload = event => {
                var contents = event.target.result
                this.readFile(contents, 'dx')
              }
              reader.readAsText(blob)
            })
        }
      }

      this.setCrimpHeel()
      // let temp = 0;
      // if (this.order.plan_realization == "no_plantar") {
      // this.order.footmeasurements["crimp_heel_sx"] = temp;
      // this.order.footmeasurements["crimp_heel_dx"] = temp;
      // }

      // if (
      // this.order.plan_realization == "reali_duna" ||
      // this.order.plan_realization == "no_plantar"
      // ) {
      // temp = parseInt(this.order.footmeasurements["high_heel_zep_sx"]) || 0;
      // this.order.footmeasurements["crimp_heel_sx"] = temp;
      // temp = parseInt(this.order.footmeasurements["thick_cen_heel_sx"]) || 0;
      // this.order.footmeasurements["crimp_heel_sx"] += temp;
      // temp = parseInt(this.order.footmeasurements["ext_high_heel_sx"]) || 0;
      // this.order.footmeasurements["crimp_heel_sx"] += temp;
      // temp = parseInt(this.order.footmeasurements["thick_pla_sx"]) || 0;
      // this.order.footmeasurements["crimp_heel_sx"] -= temp;
      // temp = parseInt(this.order.footmeasurements["ext_high_pla_sx"]) || 0;
      // this.order.footmeasurements["crimp_heel_sx"] -= temp;

      // temp = parseInt(this.order.footmeasurements["high_heel_zep_dx"]) || 0;
      // this.order.footmeasurements["crimp_heel_dx"] = temp;
      // temp = parseInt(this.order.footmeasurements["thick_cen_heel_dx"]) || 0;
      // this.order.footmeasurements["crimp_heel_dx"] += temp;
      // temp = parseInt(this.order.footmeasurements["ext_high_heel_dx"]) || 0;
      // this.order.footmeasurements["crimp_heel_dx"] += temp;
      // temp = parseInt(this.order.footmeasurements["thick_pla_dx"]) || 0;
      // this.order.footmeasurements["crimp_heel_dx"] -= temp;
      // temp = parseInt(this.order.footmeasurements["ext_high_pla_dx"]) || 0;
      // this.order.footmeasurements["crimp_heel_dx"] -= temp;
      // }
      // if (this.order.plan_realization == "reali_proper") {
      // temp = parseInt(this.order.footmeasurements["high_heel_sx"]) || 0;
      // this.order.footmeasurements["crimp_heel_sx"] = temp;
      // temp = parseInt(this.order.footmeasurements["tacc_sx"]) || 0;
      // this.order.footmeasurements["crimp_heel_sx"] += temp;
      // temp = parseInt(this.order.footmeasurements["ext_high_heel_sx"]) || 0;
      // this.order.footmeasurements["crimp_heel_sx"] += temp;
      // temp = parseInt(this.order.footmeasurements["plant_sx"]) || 0;
      // this.order.footmeasurements["crimp_heel_sx"] -= temp;
      // temp = parseInt(this.order.footmeasurements["ext_high_pla_sx"]) || 0;
      // this.order.footmeasurements["crimp_heel_sx"] -= temp;

      // temp = parseInt(this.order.footmeasurements["high_heel_dx"]) || 0;
      // this.order.footmeasurements["crimp_heel_dx"] = temp;
      // temp = parseInt(this.order.footmeasurements["tacc_dx"]) || 0;
      // this.order.footmeasurements["crimp_heel_dx"] += temp;
      // temp = parseInt(this.order.footmeasurements["ext_high_heel_dx"]) || 0;
      // this.order.footmeasurements["crimp_heel_dx"] += temp;
      // temp = parseInt(this.order.footmeasurements["plant_dx"]) || 0;
      // this.order.footmeasurements["crimp_heel_dx"] -= temp;
      // temp = parseInt(this.order.footmeasurements["ext_high_pla_dx"]) || 0;
      // this.order.footmeasurements["crimp_heel_dx"] -= temp;
      // }

      for (let varian in this.order.footmeasurements) {
        if (this.order.footmeasurements[varian] == undefined) {
          delete this.order.footmeasurements[varian]
        }
      }

      if (this.order.footmeasurements['foot_long_sx'] != undefined) {
        this.order.footmeasurements['f_long_formfoot_sx'] = this.order.footmeasurements['foot_long_sx']
      }
      if (this.order.footmeasurements['foot_long_dx'] != undefined) {
        this.order.footmeasurements['f_long_formfoot_dx'] = this.order.footmeasurements['foot_long_dx']
      }

      if (this.order.footmeasurements['high_fings_sx'] != undefined) {
        this.order.footmeasurements['f_high_pointfoot_sx'] = this.order.footmeasurements['high_fings_sx']
      }
      if (this.order.footmeasurements['high_fings_dx'] != undefined) {
        this.order.footmeasurements['f_high_pointfoot_dx'] = this.order.footmeasurements['high_fings_dx']
      }

      if (this.order.footmeasurements['circ_meta_sx'] != undefined) {
        this.order.footmeasurements['f_circ_metafoot_sx'] = this.order.footmeasurements['circ_meta_sx']
      }
      if (this.order.footmeasurements['circ_meta_dx'] != undefined) {
        this.order.footmeasurements['f_circ_metafoot_dx'] = this.order.footmeasurements['circ_meta_dx']
      }

      if (this.order.footmeasurements['circ_retro_meta_sx'] != undefined) {
        this.order.footmeasurements['f_circ_retrometafoot_sx'] = this.order.footmeasurements['circ_retro_meta_sx']
      }
      if (this.order.footmeasurements['circ_retro_meta_dx'] != undefined) {
        this.order.footmeasurements['f_circ_retrometafoot_dx'] = this.order.footmeasurements['circ_retro_meta_dx']
      }

      if (this.order.footmeasurements['circ_neck_sx'] != undefined) {
        this.order.footmeasurements['f_circ_neckfoot_sx'] = this.order.footmeasurements['circ_neck_sx']
      }
      if (this.order.footmeasurements['circ_neck_dx'] != undefined) {
        this.order.footmeasurements['f_circ_neckfoot_dx'] = this.order.footmeasurements['circ_neck_dx']
      }

      if (this.order.footmeasurements['circ_ankle_sx'] != undefined) {
        this.order.footmeasurements['f_circ_mallfoot_sx'] = this.order.footmeasurements['circ_ankle_sx']
      }
      if (this.order.footmeasurements['circ_ankle_dx'] != undefined) {
        this.order.footmeasurements['f_circ_mallfoot_dx'] = this.order.footmeasurements['circ_ankle_dx']
      }

      if (this.order.footmeasurements['circ_leg_sx'] != undefined) {
        this.order.footmeasurements['f_circ_term_tomfoot_sx'] = this.order.footmeasurements['circ_leg_sx']
      }
      if (this.order.footmeasurements['circ_leg_dx'] != undefined) {
        this.order.footmeasurements['f_circ_term_tomfoot_dx'] = this.order.footmeasurements['circ_leg_dx']
      }

      if (this.order.footmeasurements['circ_past_sx'] != undefined) {
        this.order.footmeasurements['f_circ_passfoot_sx'] = this.order.footmeasurements['circ_past_sx']
      }
      if (this.order.footmeasurements['circ_past_dx'] != undefined) {
        this.order.footmeasurements['f_circ_passfoot_dx'] = this.order.footmeasurements['circ_past_dx']
      }

      if (this.order.footmeasurements['high_leg_sx'] != undefined) {
        this.order.footmeasurements['f_high_term_tomfoot_sx'] = this.order.footmeasurements['high_leg_sx']
      }
      if (this.order.footmeasurements['high_leg_dx'] != undefined) {
        this.order.footmeasurements['f_high_term_tomfoot_dx'] = this.order.footmeasurements['high_leg_dx']
      }

      // if (this.order.footmeasurements["circ_end_tom_sx"] != undefined) {
      //  this.order.footmeasurements["f_high_term_tomfoot_sx"] =
      //    this.order.footmeasurements["circ_end_tom_sx"];
      //}
      //if (this.order.footmeasurements["circ_end_tom_dx"] != undefined) {
      //  this.order.footmeasurements["f_high_term_tomfoot_dx"] =
      //    this.order.footmeasurements["circ_end_tom_dx"];
      //}

      this.$forceUpdate()
    },
    setCrimpHeel() {
      //altezza zeppa: hz(high_heel_zep)
      //centro tacco plantare: ctp(thick_cen_heel)
      //centro tacco suola: cts(ext_high_heel)
      //centro pianta plantare: cpp(thick_pla)
      //centro pianta suola: cps(ext_high_pla)
      //centro tacco predispozione plantare: ctpp(tacc)
      //centro pianta predispozione plantare: cppp(plant)
      //nessun plantare: crimp = hz + cts - cps
      //realizzazione duna: crimp = hz + ctp + cts - ctp - cps
      //realizzazione propria: crimp = hz + ctpp + cts - cppp - cps
      const hz_sx = parseInt(this.order.footmeasurements['high_heel_zep_sx']) || 0
      const hz_dx = parseInt(this.order.footmeasurements['high_heel_zep_dx']) || 0
      const cts_sx = parseInt(this.order.footmeasurements['ext_high_heel_sx']) || 0
      const cts_dx = parseInt(this.order.footmeasurements['ext_high_heel_dx']) || 0
      const cps_sx = parseInt(this.order.footmeasurements['ext_high_pla_sx']) || 0
      const cps_dx = parseInt(this.order.footmeasurements['ext_high_pla_dx']) || 0
      let ctp_sx = 0
      let ctp_dx = 0
      let cpp_sx = 0
      let cpp_dx = 0
      if (this.order.plan_realization == 'reali_duna') {
        ctp_sx = parseInt(this.order.footmeasurements['thick_cen_heel_sx']) || 0
        ctp_dx = parseInt(this.order.footmeasurements['thick_cen_heel_dx']) || 0
        cpp_sx = parseInt(this.order.footmeasurements['thick_pla_sx']) || 0
        cpp_dx = parseInt(this.order.footmeasurements['thick_pla_dx']) || 0
      } else if (this.order.plan_realization == 'reali_proper') {
        ctp_sx = parseInt(this.order.footmeasurements['tacc_sx']) || 0
        ctp_dx = parseInt(this.order.footmeasurements['tacc_dx']) || 0
        cpp_sx = parseInt(this.order.footmeasurements['plant_sx']) || 0
        cpp_dx = parseInt(this.order.footmeasurements['plant_dx']) || 0
      }
      this.order.footmeasurements['crimp_heel_sx'] = hz_sx + cts_sx + ctp_sx - cps_sx - cpp_sx
      this.order.footmeasurements['crimp_heel_dx'] = hz_dx + cts_dx + ctp_dx - cps_dx - cpp_dx
    },
    copyplantarepropdxinsx() {
      if (this.order.footmeasurements['plant_dx'] != undefined) {
        this.order.footmeasurements['plant_sx'] = this.order.footmeasurements['plant_dx']
      }
      if (this.order.footmeasurements['tacc_dx'] != undefined) {
        this.order.footmeasurements['tacc_sx'] = this.order.footmeasurements['tacc_dx']
      }
      this.$forceUpdate()
    },
    copyplantarepropsxindx() {
      if (this.order.footmeasurements['plant_sx'] != undefined) {
        this.order.footmeasurements['plant_dx'] = this.order.footmeasurements['plant_sx']
      }
      if (this.order.footmeasurements['tacc_sx'] != undefined) {
        this.order.footmeasurements['tacc_dx'] = this.order.footmeasurements['tacc_sx']
      }
      this.$forceUpdate()
    },

    copyplantaredxinsx() {
      for (let variant in this.$plantare) {
        if (this.order.footmeasurements[this.$plantare[variant].key + '_dx'] != undefined) {
          this.order.footmeasurements[this.$plantare[variant].key + '_sx'] = this.order.footmeasurements[
            this.$plantare[variant].key + '_dx'
          ]
        }
      }
      if (this.order.secondplantdx == undefined) {
        this.order.secondplantdx = false
      }
      this.order.secondplantsx = this.order.secondplantdx
      this.see1sx = this.see1dx
      this.see2sx = this.see2dx

      for (let variant in this.$plantaremontaggio) {
        if (this.order.footmeasurements[this.$plantaremontaggio[variant].key + '_dx'] != undefined) {
          this.order.footmeasurements[this.$plantaremontaggio[variant].key + '_sx'] = this.order.footmeasurements[
            this.$plantaremontaggio[variant].key + '_dx'
          ]
        }

        if (this.order.footmeasurements[this.$plantaremontaggio[variant].key + 'var_dx'] != undefined) {
          this.order.footmeasurements[this.$plantaremontaggio[variant].key + 'var_sx'] = this.order.footmeasurements[
            this.$plantaremontaggio[variant].key + 'var_dx'
          ]
        }
        if (this.order.footmeasurements[this.$plantaremontaggio[variant].key + '_dx2'] != undefined) {
          this.order.footmeasurements[this.$plantaremontaggio[variant].key + '_sx2'] = this.order.footmeasurements[
            this.$plantaremontaggio[variant].key + '_dx2'
          ]
        }

        if (this.order.footmeasurements[this.$plantaremontaggio[variant].key + 'var_dx2'] != undefined) {
          this.order.footmeasurements[this.$plantaremontaggio[variant].key + 'var_sx2'] = this.order.footmeasurements[
            this.$plantaremontaggio[variant].key + 'var_dx2'
          ]
        }
      }
      if (this.order.footmeasurements.artificial_point_dx != undefined) {
        this.order.footmeasurements.artificial_point_sx = this.order.footmeasurements.artificial_point_dx
      }
      if (this.order.footmeasurements.artificil_point_dx_optional != undefined) {
        this.order.footmeasurements.artificil_point_sx_optional = this.order.footmeasurements.artificil_point_dx_optional
      }
      this.setCrimpHeel()
      this.$forceUpdate()
    },
    setShoeMeasure() {
      this.setShoeMeasureSide('sx')
      this.setShoeMeasureSide('dx')
    },
    setShoeMeasureSide(side) {
      let measurements = this.order.footmeasurements
      let current = measurements['measure_' + side]
      let footChanged = measurements['controllfoot_long_' + side] != measurements['foot_long_' + side]
      let formChanged = measurements['controllf_long_formplan_' + side] != measurements['f_long_formplan_' + side]
      if (current && !footChanged && !formChanged) return
      let value = this.computeShoeMeasure(measurements['foot_long_' + side], measurements['f_long_formplan_' + side])
      if (value == null) return
      this.$set(measurements, 'measure_' + side, value)
      this.$set(measurements, 'controllfoot_long_' + side, measurements['foot_long_' + side])
      this.$set(measurements, 'controllf_long_formplan_' + side, measurements['f_long_formplan_' + side])
    },
    computeShoeMeasure(footLong, formLong) {
      if (formLong) return Math.round(((formLong / 10) * 3) / 2 / 0.5) * 0.5
      if (footLong) return Math.round((((footLong / 10) * 3) / 2 + 1) / 0.5) * 0.5
      return null
    },
    copyplantaresxindx() {
      for (let variant in this.$plantare) {
        if (this.order.footmeasurements[this.$plantare[variant].key + '_sx'] != undefined) {
          this.order.footmeasurements[this.$plantare[variant].key + '_dx'] = this.order.footmeasurements[
            this.$plantare[variant].key + '_sx'
          ]
        }
      }
      if (this.order.secondplantsx == undefined) {
        this.order.secondplantsx = false
      }
      this.order.secondplantdx = this.order.secondplantsx
      this.see1dx = this.see1sx
      this.see2dx = this.see2sx

      for (let variant in this.$plantaremontaggio) {
        if (this.order.footmeasurements[this.$plantaremontaggio[variant].key + '_sx'] != undefined) {
          this.order.footmeasurements[this.$plantaremontaggio[variant].key + '_dx'] = this.order.footmeasurements[
            this.$plantaremontaggio[variant].key + '_sx'
          ]
        }

        if (this.order.footmeasurements[this.$plantaremontaggio[variant].key + 'var_sx'] != undefined) {
          this.order.footmeasurements[this.$plantaremontaggio[variant].key + 'var_dx'] = this.order.footmeasurements[
            this.$plantaremontaggio[variant].key + 'var_sx'
          ]
        }

        if (this.order.footmeasurements[this.$plantaremontaggio[variant].key + '_sx2'] != undefined) {
          this.order.footmeasurements[this.$plantaremontaggio[variant].key + '_dx2'] = this.order.footmeasurements[
            this.$plantaremontaggio[variant].key + '_sx2'
          ]
        }
        if (this.order.footmeasurements[this.$plantaremontaggio[variant].key + 'var_sx2'] != undefined) {
          this.order.footmeasurements[this.$plantaremontaggio[variant].key + 'var_dx2'] = this.order.footmeasurements[
            this.$plantaremontaggio[variant].key + 'var_sx2'
          ]
        }
      }
      if (this.order.footmeasurements.artificial_point_sx != undefined) {
        this.order.footmeasurements.artificial_point_dx = this.order.footmeasurements.artificial_point_sx
      }
      if (this.order.footmeasurements.artificil_point_sx_optional != undefined) {
        this.order.footmeasurements.artificil_point_dx_optional = this.order.footmeasurements.artificil_point_sx_optional
      }
      this.setCrimpHeel()
      this.$forceUpdate()
    },
    copyallfondxinsx() {
      for (let variant in this.$allacciaturames) {
        if (this.order.footmeasurements[this.$allacciaturames[variant].key + '_dx'] != undefined) {
          this.order.footmeasurements[this.$allacciaturames[variant].key + '_sx'] = this.order.footmeasurements[
            this.$allacciaturames[variant].key + '_dx'
          ]
        }
      }
      for (let variant in this.$fondo) {
        if (this.order.footmeasurements[this.$fondo[variant].key + '_dx'] != undefined) {
          this.order.footmeasurements[this.$fondo[variant].key + '_sx'] = this.order.footmeasurements[
            this.$fondo[variant].key + '_dx'
          ]
        }
      }

      this.setCrimpHeel()
      this.$forceUpdate()
    },
    copyallfonsxindx() {
      for (let variant in this.$allacciaturames) {
        if (this.order.footmeasurements[this.$allacciaturames[variant].key + '_sx'] != undefined) {
          this.order.footmeasurements[this.$allacciaturames[variant].key + '_dx'] = this.order.footmeasurements[
            this.$allacciaturames[variant].key + '_sx'
          ]
        }
      }
      for (let variant in this.$fondo) {
        if (this.order.footmeasurements[this.$fondo[variant].key + '_sx'] != undefined) {
          this.order.footmeasurements[this.$fondo[variant].key + '_dx'] = this.order.footmeasurements[
            this.$fondo[variant].key + '_sx'
          ]
        }
      }
      this.setCrimpHeel()
      this.$forceUpdate()
    },
    copyhighlowdxinsx() {
      let temp = []
      temp = this.$highlowmeasu
      for (let variant in temp) {
        if (this.order.footmeasurements[temp[variant].key + '_dx'] != undefined) {
          this.order.footmeasurements[temp[variant].key + '_sx'] = this.order.footmeasurements[
            temp[variant].key + '_dx'
          ]
        }
      }
      for (let variant in this.$formames) {
        if (this.order.footmeasurements[this.$formames[variant].key + 'foot_dx'] != undefined) {
          this.order.footmeasurements[this.$formames[variant].key + 'foot_sx'] = this.order.footmeasurements[
            this.$formames[variant].key + 'foot_dx'
          ]
        }

        if (this.order.footmeasurements[this.$formames[variant].key + 'plan_dx'] != undefined) {
          this.order.footmeasurements[this.$formames[variant].key + 'plan_sx'] = this.order.footmeasurements[
            this.$formames[variant].key + 'plan_dx'
          ]
        }
      }
      this.checkValue()
      this.setCrimpHeel()
      this.$forceUpdate()
    },
    copyhighlowsxindx() {
      let temp = []
      temp = this.$highlowmeasu
      for (let variant in temp) {
        if (this.order.footmeasurements[temp[variant].key + '_sx'] != undefined) {
          this.order.footmeasurements[temp[variant].key + '_dx'] = this.order.footmeasurements[
            temp[variant].key + '_sx'
          ]
        }
      }
      for (let variant in this.$formames) {
        if (this.order.footmeasurements[this.$formames[variant].key + 'foot_sx'] != undefined) {
          this.order.footmeasurements[this.$formames[variant].key + 'foot_dx'] = this.order.footmeasurements[
            this.$formames[variant].key + 'foot_sx'
          ]
        }

        if (this.order.footmeasurements[this.$formames[variant].key + 'plan_sx'] != undefined) {
          this.order.footmeasurements[this.$formames[variant].key + 'plan_dx'] = this.order.footmeasurements[
            this.$formames[variant].key + 'plan_sx'
          ]
        }
      }
      this.checkValue()
      this.setCrimpHeel()
      this.$forceUpdate()
    },
    orderScansSX() {
      var stl = 0
      var fms = 0
      var pln = 0
      this.order.scans_sx.forEach((ord, index) => {
        if (ord.name.endsWith('.stl') || ord.name.endsWith('.fms') || ord.name.endsWith('.pln')) {
          if (ord.name.endsWith('.stl')) {
            stl++
            if (stl > 1) {
              this.order.scans_sx.splice(index, 1)
            }
          }
          if (ord.name.endsWith('.fms')) {
            fms++
            if (fms > 1) {
              this.order.scans_sx.splice(index, 1)
            }
          }
          if (ord.name.endsWith('.pln')) {
            pln++
            if (pln > 1) {
              this.order.scans_sx.splice(index, 1)
            }
          }
        } else {
          this.order.scans_sx.splice(index, 1)
        }
      })
      this.order.scans_sx.forEach(ord => {
        if (ord.name.endsWith('.stl')) {
          this.order.attachment.scan_stl_sx = ord
        }
        if (ord.name.endsWith('.fms')) {
          this.order.attachment.scan_fms_sx = ord
        }
        if (ord.name.endsWith('.pln')) {
          this.order.attachment.scan_pln_sx = ord
        }
      })
      this.checkValue()
    },
    orderScansSXComparison() {
      const reader = new FileReader()
      reader.onload = event => {
        var contents = event.target.result
        this.readFileComparison(contents, 'sx')
      }
      reader.readAsText(this.scan_fms_scan_sx)
    },
    orderScansDXComparison() {
      const reader = new FileReader()
      reader.onload = event => {
        var contents = event.target.result
        this.readFileComparison(contents, 'dx')
      }
      reader.readAsText(this.scan_fms_scan_dx)
    },
    orderScansDX() {
      var stl = 0
      var fms = 0
      var pln = 0
      this.order.scans_dx.forEach((ord, index) => {
        if (ord.name.endsWith('.stl') || ord.name.endsWith('.fms') || ord.name.endsWith('.pln')) {
          if (ord.name.endsWith('.stl')) {
            stl++
            if (stl > 1) {
              this.order.scans_dx.splice(index, 1)
            }
          }
          if (ord.name.endsWith('.fms')) {
            fms++
            if (fms > 1) {
              this.order.scans_dx.splice(index, 1)
            }
          }
          if (ord.name.endsWith('.pln')) {
            pln++
            if (pln > 1) {
              this.order.scans_dx.splice(index, 1)
            }
          }
        } else {
          this.order.scans_dx.splice(index, 1)
        }
      })
      this.order.scans_dx.forEach(ord => {
        if (ord.name.endsWith('.stl')) {
          this.order.attachment.scan_stl_dx = ord
        }
        if (ord.name.endsWith('.fms')) {
          this.order.attachment.scan_fms_dx = ord
        }
        if (ord.name.endsWith('.pln')) {
          this.order.attachment.scan_pln_dx = ord
        }
      })
      this.checkValue()
    },
    attachmentSxUpdated() {
      //console.log('diocane')
      //console.log(this.order.attachment.attach_sx)
    },
    removedScanSX() {
      this.arraytodelete.scan_stl_sx = this.order.attachment.scan_stl_sx
      this.order.attachment.scan_stl_sx = null
      this.order.attachmentflag.scan_stl_sx = 0

      this.arraytodelete.scan_fms_sx = this.order.attachment.scan_fms_sx
      this.order.attachment.scan_fms_sx = null
      this.order.attachmentflag.scan_fms_sx = 0

      this.arraytodelete.scan_pln_sx = this.order.attachment.scan_pln_sx
      this.order.attachment.scan_pln_sx = null
      this.order.attachmentflag.scan_pln_sx = 0
      this.order.scans_sx = []
    },
    removedScanDX() {
      this.arraytodelete.scan_stl_dx = this.order.attachment.scan_stl_dx
      this.order.attachment.scan_stl_dx = null
      this.order.attachmentflag.scan_stl_dx = 0

      this.arraytodelete.scan_fms_dx = this.order.attachment.scan_fms_dx
      this.order.attachment.scan_fms_dx = null
      this.order.attachmentflag.scan_fms_dx = 0

      this.arraytodelete.scan_pln_dx = this.order.attachment.scan_pln_dx
      this.order.attachment.scan_pln_dx = null
      this.order.attachmentflag.scan_pln_dx = 0
      this.order.scans_dx = []
    },
    deleteScanSx(index) {
      if (this.order.scans_sx[index].name.endsWith('.stl')) {
        this.order.attachment.scan_stl_sx = null
      }
      if (this.order.scans_sx[index].name.endsWith('.fms')) {
        this.order.attachment.scan_fms_sx = null
        this.RemoveSxtemp()
      }
      if (this.order.scans_sx[index].name.endsWith('.pln')) {
        this.order.attachment.scan_pln_sx = null
      }

      this.order.scans_sx.splice(index, 1)
    },
    deleteScanDx(index) {
      if (this.order.scans_dx[index].name.endsWith('.stl')) {
        this.order.attachment.scan_stl_dx = null
      }
      if (this.order.scans_dx[index].name.endsWith('.fms')) {
        this.order.attachment.scan_fms_dx = null
        this.RemoveDxtemp()
      }
      if (this.order.scans_dx[index].name.endsWith('.pln')) {
        this.order.attachment.scan_pln_dx = null
      }

      this.order.scans_dx.splice(index, 1)
    },
    RemoveSxtemp() {
      this.tempfootmeasurementssx = {}
    },
    RemoveDxtemp() {
      this.tempfootmeasurementsdx = {}
    },
    removedFile(item) {
      this.arraytodelete[item] = this.order.attachment[item]
      this.order.attachment[item] = null
      this.order.attachmentflag[item] = 0
    },
    readFileComparison(content, side) {
      const EOL = '\n'
      var stringToFind = 'Sl='
      var pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.foot_longscan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.foot_longscan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_Ball='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.circ_metascan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.circ_metascan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_BehindBall='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.circ_retro_metascan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.circ_retro_metascan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      // stringToFind = "Pl_Ball=";
      // pos = content.indexOf(stringToFind);
      // model.metatatarsusGirth = content.substring(
      //   pos + stringToFind.length,
      //   content.indexOf(EOL, pos)
      // );

      stringToFind = 'Pl_Heel='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.circ_pastscan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.circ_pastscan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      // stringToFind = "Pl_Heel=";
      // pos = content.indexOf(stringToFind);
      // model.heelGirth = content.substring(
      //   pos + stringToFind.length,
      //   content.indexOf(EOL, pos)
      // );

      stringToFind = 'Pl_Ankle='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.circ_anklescan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.circ_anklescan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_AnkleHeight='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.high_anklescan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.high_anklescan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      // stringToFind = "Pl_Ankle=";
      // pos = content.indexOf(stringToFind);
      // model.ankleGirth = content.substring(
      //   pos + stringToFind.length,
      //   content.indexOf(EOL, pos)
      // );

      stringToFind = 'Pl_Instep='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.circ_neckscan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.circ_neckscan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_UpperEnd='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.circ_legscan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.circ_legscan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_UpperEndHeight='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.high_legscan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.high_legscan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_HeelHeight='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.high_heelscan_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.high_heelscan_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      // stringToFind = "Pl_Instep=";
      // pos = content.indexOf(stringToFind);
      // model.instepGirth = content.substring(
      //   pos + stringToFind.length,
      //   content.indexOf(EOL, pos)
      // );

      this.$forceUpdate()
    },
    readFile(content, side) {
      const EOL = '\n'
      var stringToFind = 'Sl='
      var pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.foot_long_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.foot_long_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_Ball='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.circ_meta_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.circ_meta_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_BehindBall='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.circ_retro_meta_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.circ_retro_meta_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      // stringToFind = "Pl_Ball=";
      // pos = content.indexOf(stringToFind);
      // model.metatatarsusGirth = content.substring(
      //   pos + stringToFind.length,
      //   content.indexOf(EOL, pos)
      // );

      stringToFind = 'Pl_Heel='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.circ_past_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.circ_past_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      // stringToFind = "Pl_Heel=";
      // pos = content.indexOf(stringToFind);
      // model.heelGirth = content.substring(
      //   pos + stringToFind.length,
      //   content.indexOf(EOL, pos)
      // );

      stringToFind = 'Pl_Ankle='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.circ_ankle_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.circ_ankle_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_AnkleHeight='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.high_ankle_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.high_ankle_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      // stringToFind = "Pl_Ankle=";
      // pos = content.indexOf(stringToFind);
      // model.ankleGirth = content.substring(
      //   pos + stringToFind.length,
      //   content.indexOf(EOL, pos)
      // );

      stringToFind = 'Pl_Instep='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.circ_neck_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.circ_neck_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_UpperEnd='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.circ_leg_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.circ_leg_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_UpperEndHeight='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.high_leg_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.high_leg_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      stringToFind = 'Pl_HeelHeight='
      pos = content.indexOf(stringToFind)
      if (side == 'sx') {
        this.tempfootmeasurementssx.high_heel_sx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      } else {
        this.tempfootmeasurementsdx.high_heel_dx = Math.ceil(
          content.substring(pos + stringToFind.length, content.indexOf(EOL, pos) - 1)
        ).toString()
      }

      // stringToFind = "Pl_Instep=";
      // pos = content.indexOf(stringToFind);
      // model.instepGirth = content.substring(
      //   pos + stringToFind.length,
      //   content.indexOf(EOL, pos)
      // );

      this.$forceUpdate()
    },
    importScanSxFromTemp() {
      let temp = this.$highlowmeasu
      for (let variant in temp) {
        if (this.tempfootmeasurementssx[temp[variant].key + '_sx'] != undefined) {
          this.order.footmeasurements[temp[variant].key + '_sx'] = this.tempfootmeasurementssx[
            temp[variant].key + '_sx'
          ]
        }
      }
      this.checkValue()
      this.$forceUpdate()
    },
    importScanDxFromTemp() {
      let temp = this.$highlowmeasu
      for (let variant in temp) {
        if (this.tempfootmeasurementsdx[temp[variant].key + '_dx'] != undefined) {
          this.order.footmeasurements[temp[variant].key + '_dx'] = this.tempfootmeasurementsdx[
            temp[variant].key + '_dx'
          ]
        }
      }
      this.checkValue()
      this.$forceUpdate()
    },
  },
}
</script>
<style scoped>
.container >>> td input {
  text-align: center;
}

.container >>> .is-semiuploaded {
  background-color: #ffdd57;
  color: black;
}
.container >>> .is-uploaded {
  background-color: #008a6b;
  color: white;
}

.insoleImage {
  float: right;
  width: 100px;
  height: 100px;
}
</style>
